import { ethers } from 'ethers';

var ComputeLeaseAbi = [
	{
		inputs: [
			{
				internalType: "address",
				name: "_orderRequest",
				type: "address"
			},
			{
				internalType: "address",
				name: "_escrowUser",
				type: "address"
			},
			{
				internalType: "address",
				name: "_escrowProtocol",
				type: "address"
			},
			{
				internalType: "address",
				name: "_tokenRegistryAddress",
				type: "address"
			},
			{
				internalType: "address",
				name: "_access",
				type: "address"
			},
			{
				internalType: "address",
				name: "_whitelistRegistry",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
		],
		name: "ECDSAInvalidSignature",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "length",
				type: "uint256"
			}
		],
		name: "ECDSAInvalidSignatureLength",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "ECDSAInvalidSignatureS",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidNonce",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidSignature",
		type: "error"
	},
	{
		inputs: [
		],
		name: "LeaseAlreadyTerminated",
		type: "error"
	},
	{
		inputs: [
		],
		name: "OnlyTenantOrProvider",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ReentrancyGuardReentrantCall",
		type: "error"
	},
	{
		inputs: [
		],
		name: "SignatureExpired",
		type: "error"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "escrowUser",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "escrowProtocol",
				type: "address"
			}
		],
		name: "EscrowAddressUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "leaseId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "address",
				name: "providerAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "tenantAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint32",
				name: "endTime",
				type: "uint32"
			},
			{
				indexed: false,
				internalType: "enum ComputeLease.State",
				name: "state",
				type: "uint8"
			}
		],
		name: "LeaseClosed",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "leaseId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "fizzId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint64",
				name: "requestId",
				type: "uint64"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "acceptedPrice",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "address",
				name: "providerAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "tenantAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint32",
				name: "startBlock",
				type: "uint32"
			},
			{
				indexed: false,
				internalType: "uint32",
				name: "startTime",
				type: "uint32"
			},
			{
				indexed: false,
				internalType: "uint32",
				name: "endTime",
				type: "uint32"
			},
			{
				indexed: false,
				internalType: "enum ComputeLease.State",
				name: "state",
				type: "uint8"
			}
		],
		name: "LeaseCreated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "leaseId",
				type: "uint256"
			},
			{
				indexed: true,
				internalType: "address",
				name: "providerAddress",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "tenantAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "acceptedPrice",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint32",
				name: "startBlock",
				type: "uint32"
			},
			{
				indexed: false,
				internalType: "uint32",
				name: "startTime",
				type: "uint32"
			}
		],
		name: "LeaseUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "orderRequest",
				type: "address"
			}
		],
		name: "OrderRequestUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_tokenRegistry",
				type: "address"
			}
		],
		name: "TokenRegistryContactUpdated",
		type: "event"
	},
	{
		inputs: [
		],
		name: "CLOSE_LEASE_TYPEHASH",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "DOMAIN_SEPARATOR",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "accessControl",
		outputs: [
			{
				internalType: "contract IAccessControlManager",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_leaseId",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "_acceptedPrice",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "_providerAdress",
				type: "address"
			}
		],
		name: "closeAndRenewLease",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_leaseId",
				type: "uint256"
			}
		],
		name: "closeLease",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_leaseId",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "claimedSigner",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "signature",
				type: "bytes"
			},
			{
				internalType: "uint256",
				name: "nonce",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "closeLeaseWithSignature",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint64",
				name: "_orderId",
				type: "uint64"
			},
			{
				internalType: "uint256",
				name: "_acceptedPrice",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "_providerAdress",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_fizzId",
				type: "uint256"
			}
		],
		name: "createLease",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "escrowProtocol",
		outputs: [
			{
				internalType: "contract IEscrowProtocol",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "escrowUser",
		outputs: [
			{
				internalType: "contract IEscrowUser",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_leaseId",
				type: "uint256"
			}
		],
		name: "getLeaseDetails",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "enum ComputeLease.State",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_providerAddress",
				type: "address"
			}
		],
		name: "getProviderLeases",
		outputs: [
			{
				internalType: "uint256[]",
				name: "",
				type: "uint256[]"
			},
			{
				internalType: "uint256[]",
				name: "",
				type: "uint256[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_tenantAddress",
				type: "address"
			}
		],
		name: "getTenantLeases",
		outputs: [
			{
				internalType: "uint256[]",
				name: "",
				type: "uint256[]"
			},
			{
				internalType: "uint256[]",
				name: "",
				type: "uint256[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "leases",
		outputs: [
			{
				internalType: "uint256",
				name: "leaseId",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "fizzId",
				type: "uint256"
			},
			{
				internalType: "uint64",
				name: "requestId",
				type: "uint64"
			},
			{
				internalType: "uint256",
				name: "acceptedPrice",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "providerAddress",
				type: "address"
			},
			{
				internalType: "address",
				name: "tenantAddress",
				type: "address"
			},
			{
				internalType: "uint32",
				name: "startBlock",
				type: "uint32"
			},
			{
				internalType: "uint32",
				name: "startTime",
				type: "uint32"
			},
			{
				internalType: "uint32",
				name: "endTime",
				type: "uint32"
			},
			{
				internalType: "enum ComputeLease.State",
				name: "state",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "nonces",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "orderRequest",
		outputs: [
			{
				internalType: "contract IOrderRequest",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "providerLeases",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "tenantLeases",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "tokenRegistry",
		outputs: [
			{
				internalType: "contract ITokenRegistry",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_escrowUser",
				type: "address"
			},
			{
				internalType: "address",
				name: "_escrowProtocol",
				type: "address"
			}
		],
		name: "updateEscrowAdress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_orderRequest",
				type: "address"
			}
		],
		name: "updateOrderRequestAdress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_tokenRegistry",
				type: "address"
			}
		],
		name: "updateTokenRegistryContract",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "whitelistRegistry",
		outputs: [
			{
				internalType: "contract IWhitelistRegistry",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	}
];

// Testnet Contract Addresses
const AccessControlDev = '0x87D3440372293aCf9149552546F7141AAe05Be91';
const TokenRegistryDev = '0x1aD34aF0eac1cb6B60D93594c9d3F6A0a46bd2f9';
const ProviderRegistryDev = '0x038Eb8E227B287d7D42Cf404A07ACb5a7Df7645A';
const ProviderAttributeRegistryDev = '0x63942fCb221aDF85ebdFc11a061D5eea2384f00A';
const FizzRegistryDev = '0x6cB3604EeA7Ba303bB1a020fD8e06f034D5534a3';
const FizzAttributeRegistryDev = '0xB598170D89046385C62F10670CAe2658f6D8E7D7';
const EscrowUserDev = '0xb8AC4512852409C9b30F10844c3F0a61679fAe66';
const EscrowProtocolDev = '0xbEDE87cE3411F280B3Ed63027B45f73Cbcd1B441';
const OrderRequestDev = '0xCe9787883b8f3785CCd8C8c3275B5F41068d670A';
const ComputeLeaseDev = '0x70008e46550E628D50310330686A0bc692F722Fd';
const BidDev = '0xe029A4f5e970c389Ca16e48600707496602af5Ed';
const ResourceRegistryCPUDev = '0x67B8c2201Eef00d1a8193a2aF301312DD21a286B';
const ResourceRegistryGPUDev = '0x2B73F279044347A3B6c9F122Ec6b479b6C2beAc9';
const ProviderRewardManagerDev = '0xe32279Bf9d47E20AEbb9ec04Ba5FB46536BA2aB5';
const FizzRewardManagerDev = '0xd653644FFD4ec06d173237FbA952C450A4973f5c';
const RewardTokenDev = '0xB28aA1E5074AE0222cf764e2934182775Ee7AB42';
// Testnet Token addresses
const USDTDev = '0x96Ca5955F25648FB44C5D772BAdB4313000C66Fe';
const USDCDev = '0x816413630c39780677E1584D4a6DbAFd76b161F7';
const DAIDev = '0xcF5F08686dBE94B88b93FB2E8E5482A7f432C892';
const WETHDev = '0xd74C08f8ffDF88C807367813Ad64a960618f4dcC';
const CSTDev = '0x8E5996A3963011Ca9dFa04E3CB773147F98C0e17';
const SPONDev = '0x76e593392523243ACD38ceD87c2007F14483a86B';
const uSPONDev = '0xeD8F325cDc2BA7567395cb451A2ea8FAf40E23D2';
// Mainnet Contract Addresses
const TokenRegistryMainnet = '0xDCD3eeE9f5Fb828C4EaE14B8Fe2382c0dDD6de01';
const AccessControlMainnet = '0x2F6dE416a7AEED365bE49DeB931D263EC742605C';
const ProviderRegistryMainnet = '0x79c892AE9D910bBeb81705960BA01706Bb2Af02e';
const ProviderAttributeRegistryMainnet = '0x4149Ff1496AA74F7A59989eb5332946fEed22705';
const FizzRegistryMainnet = '0x1071F508b68E9cf8f338170295C952BDF509AE4D';
const FizzAttributeRegistryMainnet = '0xB7AbA489Fe9F0eB930b8d298eD5FE669611cbf79';
const EscrowUserMainnet = '0x67Ad502B202Ac602C215B2Ba28689a71d03F9Ba4';
const EscrowProtocolMainnet = '0x7381F084D31EF2F983c95572b7DD6Ee99eE03d8d';
const OrderRequestMainnet = '0xC1A0AF3224465c2a5099C14c5A1A4f6680C30A86';
const ComputeLeaseMainnet = '0x8A9f22D855bBE978C0D47De0963a3B15022E8ce0';
const BidMainnet = '0x1582D6f9A7098B112dC76dd55a98d11d95f4702A';
const ProviderResourceRegistryCPUMainnet = '0x8Ac7BD17fA6E51E9719FaEfD8FD8Cc46ECAa93A9';
const ProviderResourceRegistryGPUMainnet = '0x360135261AB6CF9c9bBeF4c5d2B1fB9bb1671C8e';
const FizzResourceRegistryCPUMainnet = '0x285ce6294277FC29efD326c91dd3825fdEf76Ddb';
const FizzResourceRegistryGPUMainnet = '0xcfa353C1E6d3f625648f6E49D102026d63727c8A';
const ResourceRegistryFactoryMainnet = '0xF302Af7f042A6D2e6A4c1fF67e4f69109d8f4Fa0';
const ProviderRewardManagerMainnet = '0x20f2159b1082529089752Bce0549a649B0f0032C';
const FizzRewardManagerMainnet = '0x8A01206Fd078Be34b28d689C92C1f2C05B3C641B';
const RewardTokenMainnet = '0xA0c5ba7d9eccbE59000e8E67654CA5d867C6b401';
// Mainnet Token addresses
const uSPONMainnet = '0xBf0fA0461331d815A103e59929E5a19A48C30f5e';
const contractAddresses = {
    testnet: {
        accessControlManager: AccessControlDev,
        tokenRegistry: TokenRegistryDev,
        providerRegistry: ProviderRegistryDev,
        providerAttributeRegistry: ProviderAttributeRegistryDev,
        fizzRegistry: FizzRegistryDev,
        fizzAttributeRegistry: FizzAttributeRegistryDev,
        escrow: EscrowUserDev,
        escrowProtocol: EscrowProtocolDev,
        orderRequest: OrderRequestDev,
        computeLease: ComputeLeaseDev,
        bid: BidDev,
        providerResourceRegistryCPU: ResourceRegistryCPUDev,
        providerResourceRegistryGPU: ResourceRegistryGPUDev,
        fizzResourceRegistryCPU: ResourceRegistryCPUDev,
        fizzResourceRegistryGPU: ResourceRegistryGPUDev,
        providerRewardManager: ProviderRewardManagerDev,
        fizzRewardManager: FizzRewardManagerDev,
        rewardToken: RewardTokenDev,
        USDT: USDTDev,
        USDC: USDCDev,
        DAI: DAIDev,
        WETH: WETHDev,
        CST: CSTDev,
        SPON: SPONDev,
        uSPON: uSPONDev,
    },
    mainnet: {
        accessControlManager: AccessControlMainnet,
        tokenRegistry: TokenRegistryMainnet,
        providerRegistry: ProviderRegistryMainnet,
        providerAttributeRegistry: ProviderAttributeRegistryMainnet,
        fizzRegistry: FizzRegistryMainnet,
        fizzAttributeRegistry: FizzAttributeRegistryMainnet,
        escrow: EscrowUserMainnet,
        escrowProtocol: EscrowProtocolMainnet,
        orderRequest: OrderRequestMainnet,
        computeLease: ComputeLeaseMainnet,
        bid: BidMainnet,
        providerResourceRegistryCPU: ProviderResourceRegistryCPUMainnet,
        providerResourceRegistryGPU: ProviderResourceRegistryGPUMainnet,
        fizzResourceRegistryCPU: FizzResourceRegistryCPUMainnet,
        fizzResourceRegistryGPU: FizzResourceRegistryGPUMainnet,
        resourceRegistryFactory: ResourceRegistryFactoryMainnet,
        providerRewardManager: ProviderRewardManagerMainnet,
        fizzRewardManager: FizzRewardManagerMainnet,
        rewardToken: RewardTokenMainnet,
        uSPON: uSPONMainnet,
    },
};

var OrderRequestAbi = [
	{
		inputs: [
			{
				internalType: "address",
				name: "_escrowUser",
				type: "address"
			},
			{
				internalType: "address",
				name: "_escrowProtocol",
				type: "address"
			},
			{
				internalType: "address",
				name: "_tokenRegistryAddress",
				type: "address"
			},
			{
				internalType: "address",
				name: "_access",
				type: "address"
			},
			{
				internalType: "address",
				name: "_whitelistRegistry",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_maxBlockNumber",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "_minBlockNumber",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
		],
		name: "ECDSAInvalidSignature",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "length",
				type: "uint256"
			}
		],
		name: "ECDSAInvalidSignatureLength",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "ECDSAInvalidSignatureS",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InsufficientBalance",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidAddress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidAmount",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidBlockNumber",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidNonce",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidOrderState",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidSignature",
		type: "error"
	},
	{
		inputs: [
		],
		name: "LeaseAlreadyTerminated",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NotAuthorized",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NotBidContract",
		type: "error"
	},
	{
		inputs: [
		],
		name: "OrderNotActive",
		type: "error"
	},
	{
		inputs: [
		],
		name: "OrderNotFound",
		type: "error"
	},
	{
		inputs: [
		],
		name: "OrderNotMatched",
		type: "error"
	},
	{
		inputs: [
		],
		name: "OrderNotOpened",
		type: "error"
	},
	{
		inputs: [
		],
		name: "SignatureExpired",
		type: "error"
	},
	{
		inputs: [
		],
		name: "UnAuthorized",
		type: "error"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "escrowUser",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "escrowProtocol",
				type: "address"
			}
		],
		name: "EscrowAddressUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "lease",
				type: "address"
			}
		],
		name: "LeaseAddressUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "maxBlockNumber",
				type: "uint256"
			}
		],
		name: "MaxBlockNumberUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "minBlockNumber",
				type: "uint256"
			}
		],
		name: "MinBlockNumberUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint64",
				name: "orderId",
				type: "uint64"
			},
			{
				indexed: false,
				internalType: "address",
				name: "creator",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "maxPrice",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint64",
				name: "numOfBlocks",
				type: "uint64"
			},
			{
				indexed: false,
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				indexed: false,
				internalType: "string",
				name: "specs",
				type: "string"
			},
			{
				indexed: false,
				internalType: "uint16",
				name: "version",
				type: "uint16"
			},
			{
				indexed: false,
				internalType: "enum OrderRequest.Mode",
				name: "mode",
				type: "uint8"
			}
		],
		name: "OrderCreated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint64",
				name: "_orderId",
				type: "uint64"
			}
		],
		name: "OrderMarkedAsClosed",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint64",
				name: "orderId",
				type: "uint64"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "maxPrice",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "enum OrderRequest.State",
				name: "state",
				type: "uint8"
			}
		],
		name: "OrderStateChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint64",
				name: "_orderId",
				type: "uint64"
			},
			{
				indexed: false,
				internalType: "address",
				name: "user",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "maxPrice",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint64",
				name: "numOfBlocks",
				type: "uint64"
			},
			{
				indexed: false,
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				indexed: false,
				internalType: "string",
				name: "specs",
				type: "string"
			},
			{
				indexed: false,
				internalType: "uint16",
				name: "version",
				type: "uint16"
			},
			{
				indexed: false,
				internalType: "enum OrderRequest.Mode",
				name: "mode",
				type: "uint8"
			}
		],
		name: "OrderUpdateRequested",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_registryContract",
				type: "address"
			}
		],
		name: "TokenRegistryContactUpdated",
		type: "event"
	},
	{
		inputs: [
		],
		name: "CREATE_ORDER_TYPEHASH",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "DOMAIN_SEPARATOR",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "UPDATE_ORDER_TYPEHASH",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "accessControl",
		outputs: [
			{
				internalType: "contract IAccessControlManager",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "maxPrice",
						type: "uint256"
					},
					{
						internalType: "uint64",
						name: "numOfBlocks",
						type: "uint64"
					},
					{
						internalType: "address",
						name: "token",
						type: "address"
					},
					{
						internalType: "string",
						name: "spec",
						type: "string"
					},
					{
						internalType: "uint16",
						name: "version",
						type: "uint16"
					},
					{
						internalType: "enum OrderRequest.Mode",
						name: "mode",
						type: "uint8"
					},
					{
						internalType: "enum OrderRequest.Tier[]",
						name: "tier",
						type: "uint8[]"
					}
				],
				internalType: "struct OrderRequest.OrderDetails",
				name: "details",
				type: "tuple"
			}
		],
		name: "createOrder",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "maxPrice",
						type: "uint256"
					},
					{
						internalType: "uint64",
						name: "numOfBlocks",
						type: "uint64"
					},
					{
						internalType: "address",
						name: "token",
						type: "address"
					},
					{
						internalType: "string",
						name: "spec",
						type: "string"
					},
					{
						internalType: "uint16",
						name: "version",
						type: "uint16"
					},
					{
						internalType: "enum OrderRequest.Mode",
						name: "mode",
						type: "uint8"
					},
					{
						internalType: "enum OrderRequest.Tier[]",
						name: "tier",
						type: "uint8[]"
					}
				],
				internalType: "struct OrderRequest.OrderDetails",
				name: "details",
				type: "tuple"
			},
			{
				internalType: "address",
				name: "claimedSigner",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "signature",
				type: "bytes"
			},
			{
				internalType: "uint256",
				name: "nonce",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "createOrderWithSignature",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "escrowProtocol",
		outputs: [
			{
				internalType: "contract IEscrowProtocol",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "escrowUser",
		outputs: [
			{
				internalType: "contract IEscrowUser",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint64",
				name: "_orderId",
				type: "uint64"
			}
		],
		name: "getOrderById",
		outputs: [
			{
				components: [
					{
						internalType: "uint64",
						name: "id",
						type: "uint64"
					},
					{
						internalType: "uint256",
						name: "maxPrice",
						type: "uint256"
					},
					{
						internalType: "uint64",
						name: "numOfBlocks",
						type: "uint64"
					},
					{
						internalType: "address",
						name: "token",
						type: "address"
					},
					{
						internalType: "address",
						name: "creator",
						type: "address"
					},
					{
						internalType: "enum OrderRequest.State",
						name: "state",
						type: "uint8"
					},
					{
						components: [
							{
								internalType: "string",
								name: "specs",
								type: "string"
							},
							{
								internalType: "uint16",
								name: "version",
								type: "uint16"
							},
							{
								internalType: "enum OrderRequest.Mode",
								name: "mode",
								type: "uint8"
							},
							{
								internalType: "enum OrderRequest.Tier[]",
								name: "tier",
								type: "uint8[]"
							}
						],
						internalType: "struct OrderRequest.OrderSpecs",
						name: "specs",
						type: "tuple"
					}
				],
				internalType: "struct OrderRequest.InitialOrder",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_providerAddress",
				type: "address"
			}
		],
		name: "getOrderByProvider",
		outputs: [
			{
				internalType: "uint64[]",
				name: "",
				type: "uint64[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint64",
				name: "_orderId",
				type: "uint64"
			}
		],
		name: "getPendingOrderById",
		outputs: [
			{
				components: [
					{
						internalType: "uint64",
						name: "id",
						type: "uint64"
					},
					{
						internalType: "uint256",
						name: "maxPrice",
						type: "uint256"
					},
					{
						internalType: "uint64",
						name: "numOfBlocks",
						type: "uint64"
					},
					{
						internalType: "address",
						name: "token",
						type: "address"
					},
					{
						internalType: "address",
						name: "creator",
						type: "address"
					},
					{
						internalType: "enum OrderRequest.State",
						name: "state",
						type: "uint8"
					},
					{
						components: [
							{
								internalType: "string",
								name: "specs",
								type: "string"
							},
							{
								internalType: "uint16",
								name: "version",
								type: "uint16"
							},
							{
								internalType: "enum OrderRequest.Mode",
								name: "mode",
								type: "uint8"
							},
							{
								internalType: "enum OrderRequest.Tier[]",
								name: "tier",
								type: "uint8[]"
							}
						],
						internalType: "struct OrderRequest.OrderSpecs",
						name: "specs",
						type: "tuple"
					}
				],
				internalType: "struct OrderRequest.InitialOrder",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "lease",
		outputs: [
			{
				internalType: "contract IComputeLease",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "maxBlockNumber",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "minBlockNumber",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "nonces",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint64",
				name: "",
				type: "uint64"
			}
		],
		name: "orders",
		outputs: [
			{
				internalType: "uint64",
				name: "id",
				type: "uint64"
			},
			{
				internalType: "uint256",
				name: "maxPrice",
				type: "uint256"
			},
			{
				internalType: "uint64",
				name: "numOfBlocks",
				type: "uint64"
			},
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "creator",
				type: "address"
			},
			{
				internalType: "enum OrderRequest.State",
				name: "state",
				type: "uint8"
			},
			{
				components: [
					{
						internalType: "string",
						name: "specs",
						type: "string"
					},
					{
						internalType: "uint16",
						name: "version",
						type: "uint16"
					},
					{
						internalType: "enum OrderRequest.Mode",
						name: "mode",
						type: "uint8"
					},
					{
						internalType: "enum OrderRequest.Tier[]",
						name: "tier",
						type: "uint8[]"
					}
				],
				internalType: "struct OrderRequest.OrderSpecs",
				name: "specs",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint64",
				name: "",
				type: "uint64"
			},
			{
				internalType: "uint64",
				name: "",
				type: "uint64"
			}
		],
		name: "pendingOrders",
		outputs: [
			{
				internalType: "uint64",
				name: "id",
				type: "uint64"
			},
			{
				internalType: "uint256",
				name: "maxPrice",
				type: "uint256"
			},
			{
				internalType: "uint64",
				name: "numOfBlocks",
				type: "uint64"
			},
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "creator",
				type: "address"
			},
			{
				internalType: "enum OrderRequest.State",
				name: "state",
				type: "uint8"
			},
			{
				components: [
					{
						internalType: "string",
						name: "specs",
						type: "string"
					},
					{
						internalType: "uint16",
						name: "version",
						type: "uint16"
					},
					{
						internalType: "enum OrderRequest.Mode",
						name: "mode",
						type: "uint8"
					},
					{
						internalType: "enum OrderRequest.Tier[]",
						name: "tier",
						type: "uint8[]"
					}
				],
				internalType: "struct OrderRequest.OrderSpecs",
				name: "specs",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_maxBlockNumber",
				type: "uint256"
			}
		],
		name: "setMaxBlockNumber",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_minBlockNumber",
				type: "uint256"
			}
		],
		name: "setMinBlockNumber",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "tokenRegistry",
		outputs: [
			{
				internalType: "contract ITokenRegistry",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_newAddress",
				type: "address"
			},
			{
				internalType: "bool",
				name: "_isTokenRegistry",
				type: "bool"
			}
		],
		name: "updateContractAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_escrowUser",
				type: "address"
			},
			{
				internalType: "address",
				name: "_escrowProtocol",
				type: "address"
			}
		],
		name: "updateEscrowAdress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint64",
				name: "_orderId",
				type: "uint64"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "maxPrice",
						type: "uint256"
					},
					{
						internalType: "uint64",
						name: "numOfBlocks",
						type: "uint64"
					},
					{
						internalType: "address",
						name: "token",
						type: "address"
					},
					{
						internalType: "string",
						name: "spec",
						type: "string"
					},
					{
						internalType: "uint16",
						name: "version",
						type: "uint16"
					},
					{
						internalType: "enum OrderRequest.Mode",
						name: "mode",
						type: "uint8"
					},
					{
						internalType: "enum OrderRequest.Tier[]",
						name: "tier",
						type: "uint8[]"
					}
				],
				internalType: "struct OrderRequest.OrderDetails",
				name: "details",
				type: "tuple"
			}
		],
		name: "updateInitialOrder",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint64",
				name: "_orderId",
				type: "uint64"
			},
			{
				internalType: "address",
				name: "_providerAddress",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "updateInitialOrderState",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint64",
				name: "_orderId",
				type: "uint64"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "maxPrice",
						type: "uint256"
					},
					{
						internalType: "uint64",
						name: "numOfBlocks",
						type: "uint64"
					},
					{
						internalType: "address",
						name: "token",
						type: "address"
					},
					{
						internalType: "string",
						name: "spec",
						type: "string"
					},
					{
						internalType: "uint16",
						name: "version",
						type: "uint16"
					},
					{
						internalType: "enum OrderRequest.Mode",
						name: "mode",
						type: "uint8"
					},
					{
						internalType: "enum OrderRequest.Tier[]",
						name: "tier",
						type: "uint8[]"
					}
				],
				internalType: "struct OrderRequest.OrderDetails",
				name: "details",
				type: "tuple"
			},
			{
				internalType: "address",
				name: "claimedSigner",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "signature",
				type: "bytes"
			},
			{
				internalType: "uint256",
				name: "nonce",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "updateInitialOrderWithSignature",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint64",
				name: "_orderId",
				type: "uint64"
			}
		],
		name: "updateOrderStateToClosed",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint64",
				name: "_orderId",
				type: "uint64"
			},
			{
				internalType: "uint256",
				name: "_acceptedPrice",
				type: "uint256"
			}
		],
		name: "updatePendingOrder",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "whitelistRegistry",
		outputs: [
			{
				internalType: "contract IWhitelistRegistry",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	}
];

var BidAbi = [
	{
		inputs: [
			{
				internalType: "address",
				name: "_providerRegistryAddress",
				type: "address"
			},
			{
				internalType: "address",
				name: "_fizzRegistryAddress",
				type: "address"
			},
			{
				internalType: "address",
				name: "_orderRequest",
				type: "address"
			},
			{
				internalType: "address",
				name: "_lease",
				type: "address"
			},
			{
				internalType: "address",
				name: "_tokenRegistry",
				type: "address"
			},
			{
				internalType: "address",
				name: "_access",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
		],
		name: "BidPriceExceedsMaxPrice",
		type: "error"
	},
	{
		inputs: [
		],
		name: "BiddingClosed",
		type: "error"
	},
	{
		inputs: [
		],
		name: "FizzNodeNotActive",
		type: "error"
	},
	{
		inputs: [
		],
		name: "FizzNotLinkedToProvider",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidAddress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "LeaseNotActive",
		type: "error"
	},
	{
		inputs: [
		],
		name: "OrderNotActive",
		type: "error"
	},
	{
		inputs: [
		],
		name: "OrderNotFound",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ProviderHasActiveBid",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ProviderNotActive",
		type: "error"
	},
	{
		inputs: [
		],
		name: "TokenNotAccepted",
		type: "error"
	},
	{
		inputs: [
		],
		name: "UnAuthourized",
		type: "error"
	},
	{
		inputs: [
		],
		name: "UpdateOrderNotAccepted",
		type: "error"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint64",
				name: "orderId",
				type: "uint64"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "bidPrice",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "address",
				name: "provider",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "fizz",
				type: "uint256"
			}
		],
		name: "BidPlaced",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "fizzRegistry",
				type: "address"
			}
		],
		name: "FizzRegistryUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "lease",
				type: "address"
			}
		],
		name: "LeaseAddressUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint64",
				name: "orderId",
				type: "uint64"
			},
			{
				indexed: false,
				internalType: "address",
				name: "providerAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "tenant",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "acceptedPrice",
				type: "uint256"
			}
		],
		name: "LeaseUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint64",
				name: "orderId",
				type: "uint64"
			},
			{
				indexed: false,
				internalType: "address",
				name: "providerAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "fizzId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "providerId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "acceptedPrice",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "address",
				name: "creator",
				type: "address"
			}
		],
		name: "OrderMatched",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "orderRequest",
				type: "address"
			}
		],
		name: "OrderRequestAddressUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "providerRegistry",
				type: "address"
			}
		],
		name: "ProviderRegistryUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "tokenRegistry",
				type: "address"
			}
		],
		name: "TokenRegistryUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint64",
				name: "orderId",
				type: "uint64"
			},
			{
				indexed: false,
				internalType: "address",
				name: "providerAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "tenant",
				type: "address"
			}
		],
		name: "UpdateRequestAccepted",
		type: "event"
	},
	{
		inputs: [
			{
				internalType: "uint64",
				name: "_orderId",
				type: "uint64"
			}
		],
		name: "acceptUpdate",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "accessControl",
		outputs: [
			{
				internalType: "contract IAccessControlManager",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint64",
				name: "",
				type: "uint64"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "bids",
		outputs: [
			{
				internalType: "uint256",
				name: "requestId",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "provider",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "bidPrice",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "fizzId",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "timestamp",
				type: "uint256"
			},
			{
				internalType: "enum Bid.BidState",
				name: "state",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "fizzRegistry",
		outputs: [
			{
				internalType: "contract IFizzRegistry",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint64",
				name: "_orderId",
				type: "uint64"
			}
		],
		name: "getAllBidsForOrder",
		outputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "requestId",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "provider",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "bidPrice",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "fizzId",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "timestamp",
						type: "uint256"
					},
					{
						internalType: "enum Bid.BidState",
						name: "state",
						type: "uint8"
					}
				],
				internalType: "struct Bid.ProviderBid[]",
				name: "",
				type: "tuple[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint64",
				name: "_orderId",
				type: "uint64"
			},
			{
				internalType: "address",
				name: "_provider",
				type: "address"
			}
		],
		name: "getProviderOrderBid",
		outputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "requestId",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "provider",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "bidPrice",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "fizzId",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "timestamp",
						type: "uint256"
					},
					{
						internalType: "enum Bid.BidState",
						name: "state",
						type: "uint8"
					}
				],
				internalType: "struct Bid.ProviderBid",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "lease",
		outputs: [
			{
				internalType: "contract IComputeLease",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint64",
				name: "_orderId",
				type: "uint64"
			},
			{
				internalType: "address",
				name: "_providerAddress",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_acceptedPrice",
				type: "uint256"
			}
		],
		name: "matchOrder",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "orderRequest",
		outputs: [
			{
				internalType: "contract IOrderRequest",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "uint64",
				name: "",
				type: "uint64"
			}
		],
		name: "orderUpdateAcceptance",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint64",
				name: "_orderId",
				type: "uint64"
			},
			{
				internalType: "uint256",
				name: "_bidPrice",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "_fizzId",
				type: "uint256"
			}
		],
		name: "placeBid",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "uint64",
				name: "",
				type: "uint64"
			}
		],
		name: "providerActiveBid",
		outputs: [
			{
				internalType: "uint64",
				name: "",
				type: "uint64"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "uint64",
				name: "",
				type: "uint64"
			}
		],
		name: "providerOrderBid",
		outputs: [
			{
				internalType: "uint256",
				name: "requestId",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "provider",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "bidPrice",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "fizzId",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "timestamp",
				type: "uint256"
			},
			{
				internalType: "enum Bid.BidState",
				name: "state",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "providerRegistry",
		outputs: [
			{
				internalType: "contract IProviderRegistry",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "tokenRegistry",
		outputs: [
			{
				internalType: "contract ITokenRegistry",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_fizzRegistry",
				type: "address"
			}
		],
		name: "updateFizzRegistryAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_lease",
				type: "address"
			}
		],
		name: "updateLeaseAdress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint64",
				name: "_orderId",
				type: "uint64"
			},
			{
				internalType: "uint256",
				name: "_acceptedPrice",
				type: "uint256"
			}
		],
		name: "updateOrder",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_orderRequest",
				type: "address"
			}
		],
		name: "updateOrderRequestAdress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_providerRegistry",
				type: "address"
			}
		],
		name: "updateProviderAdress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_tokenRegistry",
				type: "address"
			}
		],
		name: "updateTokenRegistryAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

// Testnet Default RPC URLs
const SPHERON_TESTNET_HTTP_URL = 'https://base-sepolia-rpc.publicnode.com';
const SPHERON_TESTNET_WSS_URL = 'wss://base-sepolia-rpc.publicnode.com';
const SPHERON_TESTNET_EXPLORER_URL = 'https://sepolia.basescan.org';
// Mainnet Default RPC URLs
const SPHERON_MAINNET_HTTP_URL = 'https://mainnet.base.org';
const SPHERON_MAINNET_WSS_URL = 'wss://base-rpc.publicnode.com';
const SPHERON_MAINNET_EXPLORER_URL = 'https://basescan.org';
const SPHERON_RPC_MAP = {
    testnet: {
        http: SPHERON_TESTNET_HTTP_URL,
        wss: SPHERON_TESTNET_WSS_URL,
        explorer: SPHERON_TESTNET_EXPLORER_URL,
    },
    mainnet: {
        http: SPHERON_MAINNET_HTTP_URL,
        wss: SPHERON_MAINNET_WSS_URL,
        explorer: SPHERON_MAINNET_EXPLORER_URL,
    },
};
const tokenMap = {
    testnet: [
        {
            id: 1,
            name: 'Tether USD Test Token',
            symbol: 'USDT',
            decimal: 6,
            address: contractAddresses.testnet.USDT,
        },
        {
            id: 2,
            name: 'DAI Test Token',
            symbol: 'DAI',
            decimal: 18,
            address: contractAddresses.testnet.DAI,
        },
        {
            id: 3,
            name: 'Test Token USD Coin',
            symbol: 'USDC',
            decimal: 6,
            address: contractAddresses.testnet.USDC,
        },
        {
            id: 4,
            name: 'Wrapped ETH Test Token',
            symbol: 'WETH',
            decimal: 18,
            address: contractAddresses.testnet.WETH,
        },
        {
            id: 5,
            name: 'uSPON Test Token',
            symbol: 'uSPON',
            decimal: 6,
            address: contractAddresses.testnet.uSPON,
        },
    ],
    mainnet: [
        {
            id: 3,
            name: 'uSPON',
            symbol: 'uSPON',
            decimal: 6,
            address: contractAddresses.mainnet.uSPON,
        },
    ],
};
process.env.NEXT_PUBLIC_NETWORK_TYPE || 'mainnet';
const DEFAULT_PAGE_SIZE = 10;
const GSEQ = '1';
const OSEQ = '1';

const isValidEthereumAddress = (address) => ethers.isAddress(address);
const getTokenDetails = (tokenAddress, networkType) => {
    return (tokenMap[networkType]?.find((token) => token.address.toLowerCase() === tokenAddress.toLowerCase()) || tokenMap[networkType][0]);
};
const requestPipeline = async ({ url, method, body = undefined, }) => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    try {
        const res = await fetch(`${url}`, {
            headers,
            method,
            body,
        });
        const contentType = res.headers.get('Content-Type');
        const isJson = contentType && contentType.includes('application/json');
        if (res.status === 500) {
            throw new Error('Something went wrong');
        }
        if (res.status === 204 || res.status === 205) {
            return null;
        }
        else if (isJson) {
            return res.json();
        }
        else {
            return res.text();
        }
    }
    catch (error) {
        console.log('Error in Request Pipeline ->', error);
        throw error;
    }
};

var Tier;
(function (Tier) {
    Tier[Tier["One"] = 0] = "One";
    Tier[Tier["Two"] = 1] = "Two";
    Tier[Tier["Three"] = 2] = "Three";
    Tier[Tier["Four"] = 3] = "Four";
    Tier[Tier["Five"] = 4] = "Five";
    Tier[Tier["Six"] = 5] = "Six";
    Tier[Tier["Seven"] = 6] = "Seven";
})(Tier || (Tier = {}));
var Mode;
(function (Mode) {
    Mode[Mode["Fizz"] = 0] = "Fizz";
    Mode[Mode["Provider"] = 1] = "Provider";
})(Mode || (Mode = {}));
var OrderState;
(function (OrderState) {
    OrderState["OPEN"] = "open";
    OrderState["PROVISIONED"] = "provisioned";
    OrderState["CLOSED"] = "closed";
    OrderState["MATCHED"] = "matched";
})(OrderState || (OrderState = {}));

const getOrderStateAsString = (state) => {
    switch (state) {
        case '0':
            return OrderState.OPEN;
        case '1':
            return OrderState.PROVISIONED;
        case '2':
            return OrderState.CLOSED;
        case '3':
            return OrderState.MATCHED;
    }
};

class OrderModule {
    constructor(provider, networkType = 'mainnet', rpcProvider) {
        this.networkType = networkType;
        this.provider = provider;
        this.rpcProvider = rpcProvider;
        this.createTimeoutId = null;
        this.updateTimeoutId = null;
    }
    async createOrder(orderDetails) {
        if (typeof window?.ethereum === 'undefined') {
            console.log('Please install MetaMask');
            return;
        }
        try {
            await window.ethereum.request({ method: 'eth_requestAccounts' });
            const provider = new ethers.BrowserProvider(window.ethereum);
            const signer = await provider.getSigner();
            const contract = new ethers.Contract(contractAddresses[this.networkType].orderRequest, OrderRequestAbi, signer);
            const tx = await contract.createOrder(orderDetails);
            const receipt = await tx.wait();
            console.log('Order created successfully -> ', receipt);
            return receipt;
        }
        catch (error) {
            console.error('Error creating order -> ', error);
            throw error;
        }
    }
    async updateOrder(orderId, orderDetails) {
        if (typeof window?.ethereum === 'undefined') {
            console.log('Please install metamask');
            return;
        }
        try {
            await window.ethereum.request({ method: 'eth_requestAccounts' });
            const provider = new ethers.BrowserProvider(window.ethereum);
            const signer = await provider.getSigner();
            const contract = new ethers.Contract(contractAddresses[this.networkType].orderRequest, OrderRequestAbi, signer);
            const tx = await contract.updateInitialOrder(orderId, orderDetails);
            const receipt = await tx.wait();
            console.log('Order Update Request Sent');
            return receipt;
        }
        catch (error) {
            console.error('Error in updating order -> ', error);
            throw error;
        }
    }
    async getOrderDetails(leaseId) {
        const contractAbi = OrderRequestAbi;
        const contractAddress = contractAddresses[this.networkType].orderRequest;
        const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
        const response = await contract.getOrderById(leaseId);
        const specs = {
            specs: response.specs.specs,
            version: response.specs.version,
            mode: response.specs.mode,
            tier: response.specs.tier.map((t) => Number(t)),
        };
        const tokenDetails = getTokenDetails(response.token, this.networkType);
        const token = {
            symbol: tokenDetails?.symbol,
            decimal: tokenDetails?.decimal,
            address: tokenDetails?.address,
        };
        return {
            id: response.id.toString(),
            maxPrice: Number(response.maxPrice),
            numOfBlocks: Number(response.numOfBlocks),
            token,
            creator: response.creator,
            state: getOrderStateAsString(response.state),
            specs,
        };
    }
    async listenToOrderCreated(timeoutTime = 60000, onSuccessCallback, onFailureCallback) {
        const webSocketProvider = new ethers.WebSocketProvider(this.rpcProvider.WSS_URL);
        if (!webSocketProvider) {
            console.log('Please pass websocket provider in constructor');
            return;
        }
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        const contractAbi = BidAbi;
        const contractAddress = contractAddresses[this.networkType].bid;
        const contract = new ethers.Contract(contractAddress, contractAbi, webSocketProvider);
        return new Promise((resolve, reject) => {
            this.createTimeoutId = setTimeout(() => {
                contract.off('OrderMatched');
                webSocketProvider?.destroy();
                onFailureCallback();
                reject({ error: true, msg: 'Order creation Failed' });
            }, timeoutTime);
            contract.on('OrderMatched', (orderId, providerAddress, providerId, acceptedPrice, creatorAddress) => {
                if (creatorAddress.toString().toLowerCase() === accounts[0].toString().toLowerCase()) {
                    onSuccessCallback(orderId, providerAddress, providerId, acceptedPrice, creatorAddress);
                    webSocketProvider?.destroy();
                    contract.off('OrderMatched');
                    clearTimeout(this.createTimeoutId);
                    resolve({ orderId, providerAddress, providerId, acceptedPrice, creatorAddress });
                }
            });
        });
    }
    async listenToOrderUpdated(timeoutTime = 60000, onSuccessCallback, onFailureCallback) {
        if (typeof window?.ethereum === 'undefined') {
            console.log('Please install MetaMask');
            return;
        }
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        const contractAbi = BidAbi;
        const contractAddress = contractAddresses[this.networkType].bid;
        const webSocketProvider = new ethers.WebSocketProvider(this.rpcProvider.WSS_URL);
        const contract = new ethers.Contract(contractAddress, contractAbi, webSocketProvider);
        return new Promise((resolve, reject) => {
            this.updateTimeoutId = setTimeout(() => {
                contract.off('LeaseUpdated');
                webSocketProvider?.destroy();
                onFailureCallback();
                reject({ error: true, msg: 'Order updation Failed' });
            }, timeoutTime);
            contract.on('LeaseUpdated', (orderId, providerAddress, tenantAddress, acceptedPrice) => {
                if (tenantAddress.toString().toLowerCase() === accounts[0].toString().toLowerCase()) {
                    onSuccessCallback(orderId, providerAddress, tenantAddress, acceptedPrice?.toString());
                    webSocketProvider?.destroy();
                    contract.off('LeaseUpdated');
                    clearTimeout(this.updateTimeoutId);
                    resolve(orderId);
                }
            });
        });
    }
    async listenToOrderUpdateAccepted(timeoutTime = 60000, onSuccessCallback, onFailureCallback) {
        if (typeof window?.ethereum === 'undefined') {
            console.log('Please install MetaMask');
            return;
        }
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        const contractAbi = BidAbi;
        const contractAddress = contractAddresses[this.networkType].bid;
        const webSocketProvider = new ethers.WebSocketProvider(this.rpcProvider.WSS_URL);
        const contract = new ethers.Contract(contractAddress, contractAbi, webSocketProvider);
        return new Promise((resolve, reject) => {
            this.updateTimeoutId = setTimeout(() => {
                contract.off('UpdateRequestAccepted');
                webSocketProvider?.destroy();
                onFailureCallback();
                reject({ error: true, msg: 'Order updation Failed' });
            }, timeoutTime);
            contract.on('UpdateRequestAccepted', (orderId, providerAddress, tenantAddress) => {
                if (tenantAddress.toString().toLowerCase() === accounts[0].toString().toLowerCase()) {
                    onSuccessCallback(orderId, providerAddress);
                    webSocketProvider?.destroy();
                    contract.off('UpdateRequestAccepted');
                    clearTimeout(this.updateTimeoutId);
                    resolve(orderId);
                }
            });
        });
    }
}

var LeaseState;
(function (LeaseState) {
    LeaseState["ACTIVE"] = "active";
    LeaseState["TERMINATED"] = "terminated";
})(LeaseState || (LeaseState = {}));

const getLeaseStateAsString = (state) => {
    switch (state) {
        case '0':
            return LeaseState.ACTIVE;
        case '1':
            return LeaseState.TERMINATED;
    }
};

var EscrowProtocolAbi = [
	{
		inputs: [
			{
				internalType: "address",
				name: "_providerRegistryAddress",
				type: "address"
			},
			{
				internalType: "address",
				name: "_fizzRegistry",
				type: "address"
			},
			{
				internalType: "address",
				name: "_escrow",
				type: "address"
			},
			{
				internalType: "address",
				name: "_treasury",
				type: "address"
			},
			{
				internalType: "uint32",
				name: "_userFeePercentage",
				type: "uint32"
			},
			{
				internalType: "uint32",
				name: "_protocolFeePercentage",
				type: "uint32"
			},
			{
				internalType: "uint32",
				name: "_fizzNodePercentage",
				type: "uint32"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
		],
		name: "AccessControlBadConfirmation",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "bytes32",
				name: "neededRole",
				type: "bytes32"
			}
		],
		name: "AccessControlUnauthorizedAccount",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "available",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "required",
				type: "uint256"
			}
		],
		name: "InsufficientBalance",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidAddress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidAmount",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ReentrancyGuardReentrantCall",
		type: "error"
	},
	{
		inputs: [
		],
		name: "UnauthorizedAccess",
		type: "error"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "enum EscrowProtocol.AddressType",
				name: "_type",
				type: "uint8"
			},
			{
				indexed: true,
				internalType: "address",
				name: "_newAddress",
				type: "address"
			}
		],
		name: "AddressUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "fizzId",
				type: "uint256"
			},
			{
				indexed: true,
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "FizzMovement",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "deposit",
				type: "uint256"
			}
		],
		name: "LockedTokenTransfered",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "uint256",
				name: "fizzId",
				type: "uint256"
			},
			{
				indexed: true,
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "deposit",
				type: "uint256"
			}
		],
		name: "LockedTokenTransferedToFizz",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "previousAdminRole",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "newAdminRole",
				type: "bytes32"
			}
		],
		name: "RoleAdminChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleGranted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleRevoked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint8",
				name: "movementType",
				type: "uint8"
			}
		],
		name: "TokenMovement",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "treasury",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "TreasuryMovement",
		type: "event"
	},
	{
		inputs: [
		],
		name: "DEFAULT_ADMIN_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "MAX_PROTOCOL_FEE_PERCENTAGE",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "escrow",
		outputs: [
			{
				internalType: "contract IEscrowUser",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "fees",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "fizzNodeEarnings",
		outputs: [
			{
				internalType: "uint128",
				name: "earned",
				type: "uint128"
			},
			{
				internalType: "uint128",
				name: "withdrawn",
				type: "uint128"
			},
			{
				internalType: "uint128",
				name: "balance",
				type: "uint128"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "fizzNodePercentage",
		outputs: [
			{
				internalType: "uint32",
				name: "",
				type: "uint32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "fizzRegistry",
		outputs: [
			{
				internalType: "contract IFizzRegistry",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getProtocolFee",
		outputs: [
			{
				internalType: "uint32",
				name: "",
				type: "uint32"
			},
			{
				internalType: "uint32",
				name: "",
				type: "uint32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			}
		],
		name: "getRoleAdmin",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "grantRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "hasRole",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "protocolFeePercentage",
		outputs: [
			{
				internalType: "uint32",
				name: "",
				type: "uint32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "providerEarnings",
		outputs: [
			{
				internalType: "uint128",
				name: "earned",
				type: "uint128"
			},
			{
				internalType: "uint128",
				name: "withdrawn",
				type: "uint128"
			},
			{
				internalType: "uint128",
				name: "balance",
				type: "uint128"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "providerRegistry",
		outputs: [
			{
				internalType: "contract IProviderRegistry",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "callerConfirmation",
				type: "address"
			}
		],
		name: "renounceRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "revokeRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint32",
				name: "_protocolFee",
				type: "uint32"
			},
			{
				internalType: "uint32",
				name: "_userFee",
				type: "uint32"
			},
			{
				internalType: "uint32",
				name: "_fizzNodeFee",
				type: "uint32"
			}
		],
		name: "setPercentages",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes4",
				name: "interfaceId",
				type: "bytes4"
			}
		],
		name: "supportsInterface",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "address",
				name: "_token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "_fees",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "_isOperator",
				type: "bool"
			}
		],
		name: "transferLocked",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "fizzId",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "address",
				name: "_token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "_fees",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "_isOperator",
				type: "bool"
			}
		],
		name: "transferLockedFizz",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "treasury",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_newAddress",
				type: "address"
			},
			{
				internalType: "enum EscrowProtocol.AddressType",
				name: "_type",
				type: "uint8"
			}
		],
		name: "updateAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "userFeePercentage",
		outputs: [
			{
				internalType: "uint32",
				name: "",
				type: "uint32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_provider",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_fizzId",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "_token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "withdrawEarnings",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "withdrawFees",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var FizzRegistryAbi = [
	{
		inputs: [
			{
				internalType: "address",
				name: "_providerRegistryAddress",
				type: "address"
			},
			{
				internalType: "address",
				name: "_tokenRegistryAddress",
				type: "address"
			},
			{
				internalType: "address",
				name: "_treasury",
				type: "address"
			},
			{
				internalType: "address",
				name: "_access",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
		],
		name: "AlreadySet",
		type: "error"
	},
	{
		inputs: [
		],
		name: "FizzAlreadyRegistered",
		type: "error"
	},
	{
		inputs: [
		],
		name: "FizzNodeNotFound",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InactiveFizzNode",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidAddress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NotWhitelisted",
		type: "error"
	},
	{
		inputs: [
		],
		name: "RegistrationFeeNotPaid",
		type: "error"
	},
	{
		inputs: [
		],
		name: "StatusUnchanged",
		type: "error"
	},
	{
		inputs: [
		],
		name: "TokenAlreadyAccepted",
		type: "error"
	},
	{
		inputs: [
		],
		name: "TokenNotFound",
		type: "error"
	},
	{
		inputs: [
		],
		name: "UnregisteredToken",
		type: "error"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "bool",
				name: "autoRegister",
				type: "bool"
			}
		],
		name: "AutoRegisterStatedUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "treasury",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "FeesWithdrawn",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address[]",
				name: "fizzes",
				type: "address[]"
			}
		],
		name: "FizzAddressRemovedFromWhitelist",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address[]",
				name: "fizzes",
				type: "address[]"
			}
		],
		name: "FizzAddressWhitelisted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "fizzId",
				type: "uint256"
			},
			{
				indexed: true,
				internalType: "address",
				name: "walletAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "providerId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "string",
				name: "spec",
				type: "string"
			},
			{
				indexed: false,
				internalType: "address[]",
				name: "paymentsAccepted",
				type: "address[]"
			},
			{
				indexed: false,
				internalType: "enum FizzRegistry.FizzStatus",
				name: "status",
				type: "uint8"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "joinTimestamp",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "address",
				name: "rewardWallet",
				type: "address"
			}
		],
		name: "FizzNodeAdded",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "fizzId",
				type: "uint256"
			},
			{
				indexed: true,
				internalType: "address",
				name: "tokenAddress",
				type: "address"
			}
		],
		name: "FizzNodePaymentAdded",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "fizzId",
				type: "uint256"
			},
			{
				indexed: true,
				internalType: "address",
				name: "tokenAddress",
				type: "address"
			}
		],
		name: "FizzNodePaymentRemoved",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "fizzId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "providerId",
				type: "uint256"
			}
		],
		name: "FizzNodeProviderIdUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "fizzId",
				type: "uint256"
			}
		],
		name: "FizzNodeRemoved",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "fizzId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "string",
				name: "spec",
				type: "string"
			}
		],
		name: "FizzNodeSpecUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "FizzId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "enum FizzRegistry.FizzStatus",
				name: "status",
				type: "uint8"
			}
		],
		name: "FizzStatusUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "fizzId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "enum FizzRegistry.FizzStatus",
				name: "status",
				type: "uint8"
			}
		],
		name: "FizzUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "providerRegistry",
				type: "address"
			}
		],
		name: "ProviderRegistryUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_tokenRegistry",
				type: "address"
			}
		],
		name: "TokenRegistryContactUpdated",
		type: "event"
	},
	{
		inputs: [
		],
		name: "accessControl",
		outputs: [
			{
				internalType: "contract IAccessControlManager",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_tokenAddress",
				type: "address"
			}
		],
		name: "addAcceptedPayment",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address[]",
				name: "_fizzes",
				type: "address[]"
			}
		],
		name: "addAddressesToWhitelist",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "providerId",
						type: "uint256"
					},
					{
						internalType: "string",
						name: "spec",
						type: "string"
					},
					{
						internalType: "address",
						name: "walletAddress",
						type: "address"
					},
					{
						internalType: "address[]",
						name: "paymentsAccepted",
						type: "address[]"
					},
					{
						internalType: "address",
						name: "rewardWallet",
						type: "address"
					}
				],
				internalType: "struct FizzRegistry.FizzParams",
				name: "params",
				type: "tuple"
			}
		],
		name: "addFizzNode",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "addressToFizzId",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "fizzId",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "providerId",
						type: "uint256"
					},
					{
						internalType: "string",
						name: "spec",
						type: "string"
					},
					{
						internalType: "address",
						name: "walletAddress",
						type: "address"
					},
					{
						internalType: "address[]",
						name: "paymentsAccepted",
						type: "address[]"
					},
					{
						internalType: "enum FizzRegistry.FizzStatus",
						name: "status",
						type: "uint8"
					},
					{
						internalType: "uint256",
						name: "joinTimestamp",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "rewardWallet",
						type: "address"
					}
				],
				internalType: "struct FizzRegistry.Fizz[]",
				name: "fizzInfos",
				type: "tuple[]"
			}
		],
		name: "adminAddFizzes",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address[]",
				name: "_fizzes",
				type: "address[]"
			}
		],
		name: "adminRemoveFizzes",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_fizzId",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "_providerId",
				type: "uint256"
			}
		],
		name: "adminUpdateFizzProviderId",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_fizzId",
				type: "uint256"
			},
			{
				internalType: "string",
				name: "_spec",
				type: "string"
			}
		],
		name: "adminUpdateFizzSpec",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "fizzAcceptedTokens",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "fizzes",
		outputs: [
			{
				internalType: "uint256",
				name: "fizzId",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "providerId",
				type: "uint256"
			},
			{
				internalType: "string",
				name: "spec",
				type: "string"
			},
			{
				internalType: "address",
				name: "walletAddress",
				type: "address"
			},
			{
				internalType: "enum FizzRegistry.FizzStatus",
				name: "status",
				type: "uint8"
			},
			{
				internalType: "uint256",
				name: "joinTimestamp",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "rewardWallet",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getAllFizzNodes",
		outputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "fizzId",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "providerId",
						type: "uint256"
					},
					{
						internalType: "string",
						name: "spec",
						type: "string"
					},
					{
						internalType: "address",
						name: "walletAddress",
						type: "address"
					},
					{
						internalType: "address[]",
						name: "paymentsAccepted",
						type: "address[]"
					},
					{
						internalType: "enum FizzRegistry.FizzStatus",
						name: "status",
						type: "uint8"
					},
					{
						internalType: "uint256",
						name: "joinTimestamp",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "rewardWallet",
						type: "address"
					}
				],
				internalType: "struct FizzRegistry.Fizz[]",
				name: "",
				type: "tuple[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_fizzId",
				type: "uint256"
			}
		],
		name: "getFizz",
		outputs: [
			{
				internalType: "uint256",
				name: "providerId",
				type: "uint256"
			},
			{
				internalType: "string",
				name: "spec",
				type: "string"
			},
			{
				internalType: "address[]",
				name: "paymentsAccepted",
				type: "address[]"
			},
			{
				internalType: "enum FizzRegistry.FizzStatus",
				name: "status",
				type: "uint8"
			},
			{
				internalType: "uint256",
				name: "joinTimestamp",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "walletAddress",
				type: "address"
			},
			{
				internalType: "address",
				name: "rewardWallet",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_rewardAddress",
				type: "address"
			}
		],
		name: "getFizzAddressByRewardAddress",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_walletAddress",
				type: "address"
			}
		],
		name: "getFizzId",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_walletAddress",
				type: "address"
			}
		],
		name: "getFizzNodeByAddress",
		outputs: [
			{
				internalType: "uint256",
				name: "providerId",
				type: "uint256"
			},
			{
				internalType: "string",
				name: "spec",
				type: "string"
			},
			{
				internalType: "address[]",
				name: "paymentsAccepted",
				type: "address[]"
			},
			{
				internalType: "enum FizzRegistry.FizzStatus",
				name: "status",
				type: "uint8"
			},
			{
				internalType: "uint256",
				name: "joinTimestamp",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "rewardWallet",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_fizz",
				type: "address"
			}
		],
		name: "getFizzNodeRewardWalletByAddress",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_fizzId",
				type: "uint256"
			}
		],
		name: "getFizzNodeRewardWalletById",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_walletAddress",
				type: "address"
			}
		],
		name: "getFizzNodeStatus",
		outputs: [
			{
				internalType: "enum FizzRegistry.FizzStatus",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_fizzId",
				type: "uint256"
			}
		],
		name: "isActiveFizzNode",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_fizzID",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "_providerID",
				type: "uint256"
			}
		],
		name: "isFizzLinked",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_walletAddress",
				type: "address"
			}
		],
		name: "isRegisteredFizzNode",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_fizzId",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "_tokenAddress",
				type: "address"
			}
		],
		name: "isTokenAcceptedByFizz",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_fizz",
				type: "address"
			}
		],
		name: "isWhitelisted",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "nextFizzId",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "providerRegistry",
		outputs: [
			{
				internalType: "contract IProviderRegistry",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_tokenAddress",
				type: "address"
			}
		],
		name: "removeAcceptedPayment",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address[]",
				name: "_fizzes",
				type: "address[]"
			}
		],
		name: "removeAddressesFromWhitelist",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_fizzId",
				type: "uint256"
			}
		],
		name: "removeFizzNode",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "rewardAddressToFizzId",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_fizzAddress",
				type: "address"
			},
			{
				internalType: "enum FizzRegistry.FizzStatus",
				name: "_status",
				type: "uint8"
			}
		],
		name: "setFizzStatus",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "tokenRegistry",
		outputs: [
			{
				internalType: "contract ITokenRegistry",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "treasury",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bool",
				name: "_autoRegister",
				type: "bool"
			}
		],
		name: "updateAutoRegisterState",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_providerId",
				type: "uint256"
			}
		],
		name: "updateFizzProviderId",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "string",
				name: "_spec",
				type: "string"
			}
		],
		name: "updateFizzSpec",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_providerRegistry",
				type: "address"
			}
		],
		name: "updateProviderRegistryAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_tokenRegistry",
				type: "address"
			}
		],
		name: "updateTokenRegistryContract",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "whitelistedFizzes",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "withdrawFees",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var ProviderRegistryAbi = [
	{
		inputs: [
			{
				internalType: "address",
				name: "_tokenRegistryAddress",
				type: "address"
			},
			{
				internalType: "address",
				name: "_access",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
		],
		name: "InvalidAddress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ProviderAlreadyRegistered",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ProviderNotFound",
		type: "error"
	},
	{
		inputs: [
		],
		name: "StatusUnchanged",
		type: "error"
	},
	{
		inputs: [
		],
		name: "TokenAlreadyAccepted",
		type: "error"
	},
	{
		inputs: [
		],
		name: "TokenNotFound",
		type: "error"
	},
	{
		inputs: [
		],
		name: "UnauthorizedRegistration",
		type: "error"
	},
	{
		inputs: [
		],
		name: "UnregisteredToken",
		type: "error"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "providerId",
				type: "uint256"
			},
			{
				indexed: true,
				internalType: "address",
				name: "walletAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "string",
				name: "spec",
				type: "string"
			},
			{
				indexed: false,
				internalType: "string",
				name: "hostUri",
				type: "string"
			},
			{
				indexed: false,
				internalType: "string",
				name: "certificate",
				type: "string"
			},
			{
				indexed: false,
				internalType: "address[]",
				name: "paymentsAccepted",
				type: "address[]"
			},
			{
				indexed: false,
				internalType: "enum ProviderRegistry.ProviderStatus",
				name: "status",
				type: "uint8"
			},
			{
				indexed: false,
				internalType: "enum ProviderRegistry.TrustTier",
				name: "tier",
				type: "uint8"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "joinTimestamp",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "address",
				name: "rewardWallet",
				type: "address"
			}
		],
		name: "ProviderAdded",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "providerId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "string",
				name: "certificate",
				type: "string"
			}
		],
		name: "ProviderCertificateUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "providerId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "string",
				name: "hostUri",
				type: "string"
			}
		],
		name: "ProviderHostUriUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "providerId",
				type: "uint256"
			},
			{
				indexed: true,
				internalType: "address",
				name: "tokenAddress",
				type: "address"
			}
		],
		name: "ProviderPaymentAdded",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "providerId",
				type: "uint256"
			},
			{
				indexed: true,
				internalType: "address",
				name: "tokenAddress",
				type: "address"
			}
		],
		name: "ProviderPaymentRemoved",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "providerId",
				type: "uint256"
			}
		],
		name: "ProviderRemoved",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "providerId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "address",
				name: "rewardWallet",
				type: "address"
			}
		],
		name: "ProviderRewardWalletUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "providerId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "string",
				name: "spec",
				type: "string"
			}
		],
		name: "ProviderSpecUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "providerId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "enum ProviderRegistry.ProviderStatus",
				name: "status",
				type: "uint8"
			}
		],
		name: "ProviderStatusUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "provider",
				type: "address"
			},
			{
				indexed: false,
				internalType: "enum ProviderRegistry.TrustTier",
				name: "tier",
				type: "uint8"
			}
		],
		name: "ProviderTierUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "reward",
				type: "address"
			}
		],
		name: "RewardManagerAddressUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_tokenRegistry",
				type: "address"
			}
		],
		name: "TokenRegistryContactUpdated",
		type: "event"
	},
	{
		inputs: [
		],
		name: "VERIFIER_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "accessControl",
		outputs: [
			{
				internalType: "contract IAccessControlManager",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_tokenAddress",
				type: "address"
			}
		],
		name: "addAcceptedPayment",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "walletAddress",
						type: "address"
					},
					{
						internalType: "address[]",
						name: "paymentsAccepted",
						type: "address[]"
					},
					{
						internalType: "string",
						name: "spec",
						type: "string"
					},
					{
						internalType: "string",
						name: "hostUri",
						type: "string"
					},
					{
						internalType: "string",
						name: "certificate",
						type: "string"
					},
					{
						internalType: "address",
						name: "rewardWallet",
						type: "address"
					}
				],
				internalType: "struct ProviderRegistry.ProviderParams",
				name: "params",
				type: "tuple"
			}
		],
		name: "addProvider",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "addressToProviderId",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "providerId",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "walletAddress",
						type: "address"
					},
					{
						internalType: "address[]",
						name: "paymentsAccepted",
						type: "address[]"
					},
					{
						internalType: "string",
						name: "spec",
						type: "string"
					},
					{
						internalType: "string",
						name: "hostUri",
						type: "string"
					},
					{
						internalType: "string",
						name: "certificate",
						type: "string"
					},
					{
						internalType: "enum ProviderRegistry.ProviderStatus",
						name: "status",
						type: "uint8"
					},
					{
						internalType: "enum ProviderRegistry.TrustTier",
						name: "tier",
						type: "uint8"
					},
					{
						internalType: "uint256",
						name: "joinTimestamp",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "rewardWallet",
						type: "address"
					}
				],
				internalType: "struct ProviderRegistry.Provider[]",
				name: "providerInfos",
				type: "tuple[]"
			}
		],
		name: "adminAddProviders",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_providerId",
				type: "uint256"
			},
			{
				internalType: "string",
				name: "_spec",
				type: "string"
			}
		],
		name: "adminUpdateProviderSpec",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getAllProviders",
		outputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "providerId",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "walletAddress",
						type: "address"
					},
					{
						internalType: "address[]",
						name: "paymentsAccepted",
						type: "address[]"
					},
					{
						internalType: "string",
						name: "spec",
						type: "string"
					},
					{
						internalType: "string",
						name: "hostUri",
						type: "string"
					},
					{
						internalType: "string",
						name: "certificate",
						type: "string"
					},
					{
						internalType: "enum ProviderRegistry.ProviderStatus",
						name: "status",
						type: "uint8"
					},
					{
						internalType: "enum ProviderRegistry.TrustTier",
						name: "tier",
						type: "uint8"
					},
					{
						internalType: "uint256",
						name: "joinTimestamp",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "rewardWallet",
						type: "address"
					}
				],
				internalType: "struct ProviderRegistry.Provider[]",
				name: "",
				type: "tuple[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_providerId",
				type: "uint256"
			}
		],
		name: "getProvider",
		outputs: [
			{
				internalType: "string",
				name: "spec",
				type: "string"
			},
			{
				internalType: "string",
				name: "hostUri",
				type: "string"
			},
			{
				internalType: "string",
				name: "certificate",
				type: "string"
			},
			{
				internalType: "address[]",
				name: "paymentsAccepted",
				type: "address[]"
			},
			{
				internalType: "enum ProviderRegistry.ProviderStatus",
				name: "status",
				type: "uint8"
			},
			{
				internalType: "enum ProviderRegistry.TrustTier",
				name: "tier",
				type: "uint8"
			},
			{
				internalType: "uint256",
				name: "joinTimestamp",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "walletAddress",
				type: "address"
			},
			{
				internalType: "address",
				name: "rewardWallet",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_rewardAddress",
				type: "address"
			}
		],
		name: "getProviderAddressByRewardAddress",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_walletAddress",
				type: "address"
			}
		],
		name: "getProviderByAddress",
		outputs: [
			{
				internalType: "string",
				name: "spec",
				type: "string"
			},
			{
				internalType: "string",
				name: "hostUri",
				type: "string"
			},
			{
				internalType: "string",
				name: "certificate",
				type: "string"
			},
			{
				internalType: "address[]",
				name: "paymentsAccepted",
				type: "address[]"
			},
			{
				internalType: "enum ProviderRegistry.ProviderStatus",
				name: "status",
				type: "uint8"
			},
			{
				internalType: "enum ProviderRegistry.TrustTier",
				name: "tier",
				type: "uint8"
			},
			{
				internalType: "uint256",
				name: "joinTimestamp",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "rewardWallet",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_walletAddress",
				type: "address"
			}
		],
		name: "getProviderId",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_walletAddress",
				type: "address"
			}
		],
		name: "getProviderRewardWallet",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_walletAddress",
				type: "address"
			}
		],
		name: "getProviderStatus",
		outputs: [
			{
				internalType: "enum ProviderRegistry.ProviderStatus",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_walletAddress",
				type: "address"
			}
		],
		name: "getProviderTrustTier",
		outputs: [
			{
				internalType: "enum ProviderRegistry.TrustTier",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_providerId",
				type: "uint256"
			}
		],
		name: "getProviderWallet",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_walletAddress",
				type: "address"
			}
		],
		name: "isActiveProvider",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_walletAddress",
				type: "address"
			}
		],
		name: "isRegisteredProvider",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_walletAddress",
				type: "address"
			},
			{
				internalType: "address",
				name: "_tokenAddress",
				type: "address"
			}
		],
		name: "isTokenAcceptedByProvider",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "nextProviderId",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "providerAcceptedTokens",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "providerRewardManager",
		outputs: [
			{
				internalType: "contract IProviderRewardsManager",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "providers",
		outputs: [
			{
				internalType: "uint256",
				name: "providerId",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "walletAddress",
				type: "address"
			},
			{
				internalType: "string",
				name: "spec",
				type: "string"
			},
			{
				internalType: "string",
				name: "hostUri",
				type: "string"
			},
			{
				internalType: "string",
				name: "certificate",
				type: "string"
			},
			{
				internalType: "enum ProviderRegistry.ProviderStatus",
				name: "status",
				type: "uint8"
			},
			{
				internalType: "enum ProviderRegistry.TrustTier",
				name: "tier",
				type: "uint8"
			},
			{
				internalType: "uint256",
				name: "joinTimestamp",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "rewardWallet",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_tokenAddress",
				type: "address"
			}
		],
		name: "removeAcceptedPayment",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_providerId",
				type: "uint256"
			}
		],
		name: "removeProvider",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "rewardAddressToProviderId",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_providerAddress",
				type: "address"
			},
			{
				internalType: "enum ProviderRegistry.ProviderStatus",
				name: "_status",
				type: "uint8"
			}
		],
		name: "setProviderStatus",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "tokenRegistry",
		outputs: [
			{
				internalType: "contract ITokenRegistry",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "string",
				name: "_certificate",
				type: "string"
			}
		],
		name: "updateProviderCertificate",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "string",
				name: "_hostUri",
				type: "string"
			}
		],
		name: "updateProviderHostUri",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_rewardWallet",
				type: "address"
			}
		],
		name: "updateProviderRewardAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "string",
				name: "_spec",
				type: "string"
			}
		],
		name: "updateProviderSpec",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_provider",
				type: "address"
			},
			{
				internalType: "enum ProviderRegistry.TrustTier",
				name: "_tier",
				type: "uint8"
			}
		],
		name: "updateProviderTier",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_rewardManager",
				type: "address"
			}
		],
		name: "updateRewardAdress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_tokenRegistry",
				type: "address"
			}
		],
		name: "updateTokenRegistryContract",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var FizzAttributeRegistryAbi = [
	{
		inputs: [
			{
				internalType: "address",
				name: "_fizzRegistryAddress",
				type: "address"
			},
			{
				internalType: "address",
				name: "_access",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
		],
		name: "AlreadySet",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ArrayMismatch",
		type: "error"
	},
	{
		inputs: [
		],
		name: "DuplicateId",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyArray",
		type: "error"
	},
	{
		inputs: [
		],
		name: "FizzNodeNotFound",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidAddress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidUnit",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NoPendingAttributes",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ProviderNotActive",
		type: "error"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "bool",
				name: "autoApprove",
				type: "bool"
			}
		],
		name: "AutoApprovalStateUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "submitter",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "totalProcessed",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "successCount",
				type: "uint256"
			}
		],
		name: "BatchAttributesSubmitted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "fizz",
				type: "address"
			},
			{
				indexed: false,
				internalType: "string",
				name: "category",
				type: "string"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "id",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "units",
						type: "uint256"
					}
				],
				indexed: false,
				internalType: "struct FizzAttributeRegistry.Attribute[]",
				name: "attributes",
				type: "tuple[]"
			}
		],
		name: "FizzAttributesApproved",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "fizz",
				type: "address"
			},
			{
				indexed: false,
				internalType: "string",
				name: "category",
				type: "string"
			}
		],
		name: "FizzAttributesRemoved",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "fizz",
				type: "address"
			},
			{
				indexed: false,
				internalType: "string",
				name: "category",
				type: "string"
			},
			{
				indexed: false,
				internalType: "uint256[]",
				name: "ids",
				type: "uint256[]"
			},
			{
				indexed: false,
				internalType: "uint256[]",
				name: "units",
				type: "uint256[]"
			}
		],
		name: "FizzAttributesSubmitted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "fizzRegistry",
				type: "address"
			}
		],
		name: "FizzRegistryUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "reward",
				type: "address"
			}
		],
		name: "FizzRewardManagerUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "fizzRegistry",
				type: "address"
			}
		],
		name: "ProviderRegistryUpdated",
		type: "event"
	},
	{
		inputs: [
		],
		name: "accessControl",
		outputs: [
			{
				internalType: "contract IAccessControlManager",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "fizzAddress",
				type: "address"
			},
			{
				internalType: "string",
				name: "category",
				type: "string"
			}
		],
		name: "adminRemoveAttributes",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "id",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "units",
						type: "uint256"
					}
				],
				internalType: "struct FizzAttributeRegistry.Attribute[]",
				name: "attributes",
				type: "tuple[]"
			},
			{
				internalType: "address",
				name: "fizz",
				type: "address"
			},
			{
				internalType: "string",
				name: "category",
				type: "string"
			}
		],
		name: "adminSetAttributes",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "fizz",
				type: "address"
			},
			{
				internalType: "string",
				name: "category",
				type: "string"
			}
		],
		name: "approveAttributes",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address[]",
				name: "fizzes",
				type: "address[]"
			},
			{
				internalType: "string",
				name: "category",
				type: "string"
			}
		],
		name: "batchApproveAttributes",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "provider",
						type: "address"
					},
					{
						internalType: "string",
						name: "category",
						type: "string"
					},
					{
						internalType: "uint256[]",
						name: "ids",
						type: "uint256[]"
					},
					{
						internalType: "uint256[]",
						name: "units",
						type: "uint256[]"
					}
				],
				internalType: "struct FizzAttributeRegistry.BatchAttributeInput[]",
				name: "batchData",
				type: "tuple[]"
			}
		],
		name: "batchSubmitAttributes",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "string",
				name: "",
				type: "string"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "fizzAttributes",
		outputs: [
			{
				internalType: "uint256",
				name: "id",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "units",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "fizzRegistry",
		outputs: [
			{
				internalType: "contract IFizzRegistry",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "fizzRewardManager",
		outputs: [
			{
				internalType: "contract IFizzRewardsManager",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_fizzAddress",
				type: "address"
			},
			{
				internalType: "string",
				name: "_category",
				type: "string"
			}
		],
		name: "getAttributes",
		outputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "id",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "units",
						type: "uint256"
					}
				],
				internalType: "struct FizzAttributeRegistry.Attribute[]",
				name: "",
				type: "tuple[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_fizz",
				type: "address"
			}
		],
		name: "getFizzNodeRewardWalletByAddress",
		outputs: [
			{
				internalType: "address",
				name: "rewardWallet",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_fizzAddress",
				type: "address"
			},
			{
				internalType: "string",
				name: "_category",
				type: "string"
			}
		],
		name: "getPendingAttributes",
		outputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "id",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "units",
						type: "uint256"
					}
				],
				internalType: "struct FizzAttributeRegistry.Attribute[]",
				name: "",
				type: "tuple[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "string",
				name: "",
				type: "string"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "pendingAttributes",
		outputs: [
			{
				internalType: "uint256",
				name: "id",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "units",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "string",
				name: "category",
				type: "string"
			}
		],
		name: "removeAttributes",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "string",
				name: "category",
				type: "string"
			},
			{
				internalType: "uint256[]",
				name: "ids",
				type: "uint256[]"
			},
			{
				internalType: "uint256[]",
				name: "units",
				type: "uint256[]"
			}
		],
		name: "submitAttributes",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bool",
				name: "_autoApprove",
				type: "bool"
			}
		],
		name: "updateAutoApprovalState",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_fizzRegistry",
				type: "address"
			}
		],
		name: "updateFizzRegistryAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_rewardManager",
				type: "address"
			}
		],
		name: "updateRewardAdress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var ResourceRegistryAbi = [
	{
		inputs: [
		],
		name: "AccessControlBadConfirmation",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "bytes32",
				name: "neededRole",
				type: "bytes32"
			}
		],
		name: "AccessControlUnauthorizedAccount",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidInitialization",
		type: "error"
	},
	{
		inputs: [
		],
		name: "NotInitializing",
		type: "error"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint64",
				name: "version",
				type: "uint64"
			}
		],
		name: "Initialized",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "resourceID",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "string",
				name: "name",
				type: "string"
			},
			{
				indexed: false,
				internalType: "string",
				name: "tier",
				type: "string"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "multiplier",
				type: "uint256"
			}
		],
		name: "ResourceAdded",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "resourceID",
				type: "uint256"
			}
		],
		name: "ResourceDeleted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "resourceID",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "string",
				name: "name",
				type: "string"
			},
			{
				indexed: false,
				internalType: "string",
				name: "tier",
				type: "string"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "multiplier",
				type: "uint256"
			}
		],
		name: "ResourceUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "previousAdminRole",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "newAdminRole",
				type: "bytes32"
			}
		],
		name: "RoleAdminChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleGranted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleRevoked",
		type: "event"
	},
	{
		inputs: [
		],
		name: "DEFAULT_ADMIN_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256[]",
				name: "_resourceIDs",
				type: "uint256[]"
			},
			{
				internalType: "string[]",
				name: "_names",
				type: "string[]"
			},
			{
				internalType: "string[]",
				name: "_tiers",
				type: "string[]"
			},
			{
				internalType: "uint256[]",
				name: "_multipliers",
				type: "uint256[]"
			}
		],
		name: "addResource",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256[]",
				name: "_resourceIDs",
				type: "uint256[]"
			}
		],
		name: "deleteResource",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_resourceID",
				type: "uint256"
			}
		],
		name: "getResource",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			},
			{
				internalType: "string",
				name: "",
				type: "string"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			}
		],
		name: "getRoleAdmin",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "grantRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "hasRole",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "string",
				name: "_resourceType",
				type: "string"
			},
			{
				internalType: "address",
				name: "_admin",
				type: "address"
			}
		],
		name: "initialize",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "callerConfirmation",
				type: "address"
			}
		],
		name: "renounceRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "resourceCounter",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "resourceType",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "resources",
		outputs: [
			{
				internalType: "string",
				name: "name",
				type: "string"
			},
			{
				internalType: "string",
				name: "tier",
				type: "string"
			},
			{
				internalType: "uint256",
				name: "multiplier",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "exists",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "revokeRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes4",
				name: "interfaceId",
				type: "bytes4"
			}
		],
		name: "supportsInterface",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256[]",
				name: "_resourceIDs",
				type: "uint256[]"
			},
			{
				internalType: "string[]",
				name: "_names",
				type: "string[]"
			},
			{
				internalType: "string[]",
				name: "_tiers",
				type: "string[]"
			},
			{
				internalType: "uint256[]",
				name: "_multipliers",
				type: "uint256[]"
			}
		],
		name: "updateResource",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var FizzProviderStatus;
(function (FizzProviderStatus) {
    FizzProviderStatus[FizzProviderStatus["Unregistered"] = 0] = "Unregistered";
    FizzProviderStatus[FizzProviderStatus["Registered"] = 1] = "Registered";
    FizzProviderStatus[FizzProviderStatus["Active"] = 2] = "Active";
    FizzProviderStatus[FizzProviderStatus["Maintenance"] = 3] = "Maintenance";
    FizzProviderStatus[FizzProviderStatus["Suspended"] = 4] = "Suspended";
    FizzProviderStatus[FizzProviderStatus["Deactivated"] = 5] = "Deactivated";
})(FizzProviderStatus || (FizzProviderStatus = {}));
var FizzProviderTrustTier;
(function (FizzProviderTrustTier) {
    FizzProviderTrustTier[FizzProviderTrustTier["One"] = 0] = "One";
    FizzProviderTrustTier[FizzProviderTrustTier["Two"] = 1] = "Two";
    FizzProviderTrustTier[FizzProviderTrustTier["Three"] = 2] = "Three";
    FizzProviderTrustTier[FizzProviderTrustTier["Four"] = 3] = "Four";
    FizzProviderTrustTier[FizzProviderTrustTier["Five"] = 4] = "Five";
    FizzProviderTrustTier[FizzProviderTrustTier["Six"] = 5] = "Six";
    FizzProviderTrustTier[FizzProviderTrustTier["Seven"] = 6] = "Seven";
})(FizzProviderTrustTier || (FizzProviderTrustTier = {}));

const decompressProviderSpec = (input) => {
    // Replace keys with the proper JSON key names
    let formattedString = input
        .replace(/n:/g, '"Name":')
        .replace(/r:/g, '"Region":')
        .replace(/a:/g, '"Attributes":')
        .replace(/k:/g, '"Key":')
        .replace(/v:/g, '"Value":');
    // Add quotes around values (excluding numbers, booleans, and already quoted values)
    formattedString = formattedString.replace(/:([\w\s./-]+)([},\]])/g, (match, p1, p2) => {
        // If the value is not already quoted and is not a number/boolean, add quotes
        if (!/^".*"$/.test(p1) && isNaN(Number(p1)) && p1 !== 'true' && p1 !== 'false') {
            return `:"${p1.trim()}"${p2}`;
        }
        return match;
    });
    // Parse the formatted string into JSON
    try {
        return JSON.parse(formattedString);
    }
    catch (error) {
        throw error;
    }
};
const decompressOrderSpecData = (compressed) => {
    const mapping = {
        n: 'Name',
        pr: 'PlacementsRequirement',
        pw: 'ProviderWallets',
        a: 'Attributes',
        k: 'Key',
        v: 'Value',
        // s: "Services", // Top level only
        r: 'Resources',
        i: 'ID',
        c: 'CPU',
        m: 'Memory',
        s: 'Storage',
        g: 'GPU',
        e: 'Endpoints',
        u: 'Units',
        t: 'Type',
    };
    const parseAttributes = (arr) => {
        return arr.map((attr) => ({
            Key: attr.k,
            Value: attr.v,
        }));
    };
    const parseEndpoints = (arr) => {
        return arr.map((endpoint) => ({
            Kind: endpoint.k,
            SequenceNumber: endpoint.s,
        }));
    };
    const transform = (obj, isTopLevel = false) => {
        if (Array.isArray(obj)) {
            return obj.map((item) => transform(item));
        }
        else if (typeof obj === 'object' && obj !== null) {
            const transformed = {};
            for (const key in obj) {
                // Replace "s" with "Services" only at the top level, otherwise use "Resources"
                const mappedKey = isTopLevel && key === 's' ? mapping.s : mapping[key] || key;
                if (mappedKey === 'Attributes' && Array.isArray(obj[key])) {
                    transformed[mappedKey] = parseAttributes(obj[key]);
                }
                else if (mappedKey === 'Endpoints' && Array.isArray(obj[key])) {
                    transformed[mappedKey] = parseEndpoints(obj[key]);
                }
                else {
                    transformed[mappedKey] = transform(obj[key]);
                }
            }
            return transformed;
        }
        return obj;
    };
    // Preprocess the compressed string to make it JSON-compliant
    const preprocess = (str) => {
        return str
            .replace(/([{,])(\w+):/g, '$1"$2":') // Add quotes around keys
            .replace(/:([\w\-\/;]+)/g, ':"$1"') // Add quotes around values, including paths and semicolon-separated values
            .replace(/:"(\d+|true|false|null)"/g, ':$1') // Remove quotes from numbers, booleans, and null
            .replace(/},\s*}/g, '}}') // Remove trailing commas before closing braces
            .replace(/],\s*}/g, ']}'); // Remove trailing commas in arrays
    };
    // Preprocess and parse the input string
    const preprocessedString = preprocess(compressed.replace(/\s/g, ''));
    const parsed = JSON.parse(preprocessedString);
    return transform(parsed, true);
};
const renameFields = (data) => {
    if (data.Storage) {
        // Rename the top-level "Storage" key to "Services"
        data.Services = data.Storage;
        delete data.Storage;
        // Iterate over each service in the Services array
        data.Services.forEach((service) => {
            if (service.CPU) {
                // Rename "CPU" to "ReplicaCount"
                service.ReplicaCount = service.CPU;
                delete service.CPU;
            }
        });
    }
    return data;
};
const decompressOrderSpec = (compressedString) => {
    return renameFields(decompressOrderSpecData(compressedString));
};

/* eslint-disable @typescript-eslint/no-explicit-any */
class FizzModule {
    constructor(provider, networkType = 'mainnet', rpcProvider) {
        this.networkType = networkType;
        this.provider = provider;
        this.rpcProvider = rpcProvider;
    }
    async getFizzEarnings(fizzAddress, tokenAddress) {
        try {
            const contractAbi = EscrowProtocolAbi;
            const contractAddress = contractAddresses[this.networkType].escrowProtocol;
            const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
            const response = await contract.getFizzNodeEarnings(fizzAddress, tokenAddress);
            const fizzEarnings = {
                earned: response[0].toString(),
                withdrawn: response[1].toString(),
                balance: response[2].toString(),
            };
            console.log('fizz earnings -> ', fizzEarnings);
            return fizzEarnings;
        }
        catch (error) {
            console.error('Error in getFizzEarnings:', error);
            throw error;
        }
    }
    async addFizzNode(fizzParams) {
        try {
            if (typeof window?.ethereum === 'undefined') {
                console.log('Please install MetaMask');
                return 'MetaMask not installed';
            }
            await window.ethereum.request({ method: 'eth_requestAccounts' });
            const provider = new ethers.BrowserProvider(window.ethereum);
            const signer = await provider.getSigner();
            const contractAddress = contractAddresses[this.networkType].fizzRegistry;
            const abi = FizzRegistryAbi;
            const contract = new ethers.Contract(contractAddress, abi, signer);
            const tx = await contract.addFizzNode(fizzParams);
            const receipt = await tx.wait();
            console.log('Fizz registration successful: ', receipt);
            return tx;
        }
        catch (error) {
            console.error('Fizz registration failed: ', error);
            throw error;
        }
    }
    async updateFizzName(newName) {
        try {
            if (typeof window?.ethereum === 'undefined') {
                console.log('Please install MetaMask');
                return 'MetaMask not installed';
            }
            await window.ethereum.request({ method: 'eth_requestAccounts' });
            const provider = new ethers.BrowserProvider(window.ethereum);
            const signer = await provider.getSigner();
            // Contract address (hardcoded or retrieved from an environment variable)
            const contractAddress = contractAddresses[this.networkType].fizzRegistry;
            const abi = FizzRegistryAbi;
            const contract = new ethers.Contract(contractAddress, abi, signer);
            const tx = await contract.updateFizzName(newName);
            const receipt = await tx.wait();
            console.log('Update Fizz Name successful: ', receipt);
            return tx;
        }
        catch (error) {
            console.error('Update Fizz Name failed: ', error);
            throw error;
        }
    }
    async getFizzById(fizzId) {
        try {
            const contractAddress = contractAddresses[this.networkType].fizzRegistry;
            const contractAbi = FizzRegistryAbi;
            const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
            const fizzDetails = await contract.getFizz(fizzId);
            const { providerId, spec, paymentsAccepted, status, joinTimestamp, walletAddress, rewardWallet, } = fizzDetails;
            return {
                region: spec?.split(',')?.[7] ?? '',
                providerId,
                spec,
                paymentsAccepted,
                status,
                joinTimestamp,
                walletAddress,
                rewardWallet,
            };
        }
        catch (error) {
            console.error('Failed to retrieve Fizz details: ', error);
            throw error;
        }
    }
    async getFizzNodeByAddress(walletAddress) {
        try {
            const contractAddress = contractAddresses[this.networkType].fizzRegistry;
            const contractAbi = FizzRegistryAbi;
            const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
            const fizzId = await contract.addressToFizzId(walletAddress);
            const fizzNode = await this.getFizzById(fizzId);
            const result = {
                region: fizzNode.spec?.split(',')?.[7] ?? '',
                fizzId,
                providerId: fizzNode.providerId,
                spec: fizzNode.spec,
                walletAddress: fizzNode.walletAddress,
                paymentsAccepted: fizzNode.paymentsAccepted,
                status: Number(fizzNode.status.toString()),
                joinTimestamp: fizzNode.joinTimestamp,
                rewardWallet: fizzNode.rewardWallet,
            };
            console.log('Fizz Node details: ', result);
            return result;
        }
        catch (error) {
            console.error('Failed to fetch Fizz Node details: ', error);
            throw error;
        }
    }
    async getAllFizzNodes() {
        try {
            const contractAddress = contractAddresses[this.networkType].fizzRegistry;
            const contractAbi = FizzRegistryAbi;
            const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
            const allFizzNodes = await contract.getAllFizzNodes();
            const fizzNodes = allFizzNodes.map((fizzNode) => ({
                fizzId: fizzNode[0],
                providerId: fizzNode[1],
                spec: fizzNode[2],
                walletAddress: fizzNode[3],
                paymentsAccepted: fizzNode[4],
                status: fizzNode[5],
                joinTimestamp: fizzNode[6],
                rewardWallet: fizzNode[7],
            }));
            console.log('All Fizz Nodes: ', fizzNodes);
            return fizzNodes;
        }
        catch (error) {
            console.error('Failed to fetch all Fizz Nodes: ', error);
            throw error;
        }
    }
    async submitAttributes(category, ids, units) {
        try {
            const provider = new ethers.BrowserProvider(window.ethereum);
            await provider.send('eth_requestAccounts', []);
            const signer = await provider.getSigner();
            const contractAddress = contractAddresses[this.networkType].fizzAttributeRegistry;
            const contractAbi = FizzAttributeRegistryAbi;
            const contract = new ethers.Contract(contractAddress, contractAbi, signer);
            const tx = await contract.submitAttributes(category, ids, units);
            const result = await tx.wait();
            console.log('Attributes submitted successfully.');
            return result;
        }
        catch (error) {
            console.error('Failed to submit attributes: ', error);
        }
    }
    async getAttributes(fizzAddress, category) {
        try {
            const contractAddress = contractAddresses[this.networkType].fizzAttributeRegistry;
            const contractAbi = FizzAttributeRegistryAbi;
            const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
            const attributes = await contract.getAttributes(fizzAddress, category);
            console.log('attributes raw -> ', attributes);
            const decoratedAttributes = attributes.map((attr) => ({
                id: attr[0],
                units: attr[1],
            }));
            console.log(`Attributes for ${fizzAddress} in category ${category} retrieved successfully:`, decoratedAttributes);
            return decoratedAttributes;
        }
        catch (error) {
            console.error('Failed to retrieve attributes: ', error);
            throw error;
        }
    }
    async getPendingAttributes(fizzAddress, category) {
        try {
            const contractAddress = contractAddresses[this.networkType].fizzAttributeRegistry;
            const contractAbi = FizzAttributeRegistryAbi;
            const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
            const attributes = await contract.getPendingAttributes(fizzAddress, category);
            const decoratedAttributes = attributes.map((attr) => ({
                id: attr[0],
                units: attr[1],
            }));
            console.log(`Pending Attributes for ${fizzAddress} in category ${category} retrieved successfully:`, decoratedAttributes);
            return decoratedAttributes;
        }
        catch (error) {
            console.error('Failed to retrieve pending attributes: ', error);
            throw error;
        }
    }
    async getResource(resourceID, category) {
        try {
            const contractAbi = ResourceRegistryAbi;
            const contractAddress = category === 'CPU'
                ? contractAddresses[this.networkType].fizzResourceRegistryCPU
                : contractAddresses[this.networkType].fizzResourceRegistryGPU;
            const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
            const [name, tier, multiplier] = await contract.getResource(resourceID);
            const resource = { name, tier, multiplier };
            console.log(`Resource with ID ${resourceID} retrieved successfully:`, resource);
            return resource;
        }
        catch (error) {
            console.error('Failed to retrieve resource: ', error);
            throw error;
        }
    }
    async getProvider(providerId) {
        try {
            const contractAddress = contractAddresses[this.networkType].providerRegistry;
            const contractAbi = ProviderRegistryAbi;
            const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
            const providerData = await contract.getProvider(providerId);
            let name, region;
            try {
                const { Name, Region } = JSON.parse(providerData.spec);
                name = Name;
                region = Region;
            }
            catch {
                try {
                    const { Name, Region } = decompressProviderSpec(providerData.spec);
                    name = Name;
                    region = Region;
                }
                catch {
                    name = '';
                    region = '';
                }
            }
            return {
                name,
                region,
                spec: providerData.spec,
                hostUri: providerData.hostUri,
                certificate: providerData.certificate,
                paymentsAccepted: providerData.paymentsAccepted,
                status: providerData.status,
                tier: providerData.tier,
                joinTimestamp: providerData.joinTimestamp,
                walletAddress: providerData.walletAddress,
                rewardWallet: providerData.rewardWallet,
            };
        }
        catch (error) {
            console.error('Failed to retrieve provider details: ', error);
            throw error;
        }
    }
    async getProviderByAddress(walletAddress) {
        try {
            const contractAddress = contractAddresses[this.networkType].providerRegistry;
            const contractAbi = ProviderRegistryAbi;
            const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
            const providerData = await contract.getProviderByAddress(walletAddress);
            let name, region;
            try {
                const { Name, Region } = JSON.parse(providerData.spec);
                name = Name;
                region = Region;
            }
            catch {
                try {
                    const { Name, Region } = decompressProviderSpec(providerData.spec);
                    name = Name;
                    region = Region;
                }
                catch {
                    name = '';
                    region = '';
                }
            }
            return {
                name,
                region,
                spec: providerData.spec,
                hostUri: providerData.hostUri,
                certificate: providerData.certificate,
                paymentsAccepted: providerData.paymentsAccepted,
                status: providerData.status,
                tier: providerData.tier,
                joinTimestamp: providerData.joinTimestamp,
                rewardWallet: providerData.rewardWallet,
            };
        }
        catch (error) {
            console.error('Failed to retrieve provider details by address: ', error);
            throw error;
        }
    }
    async getAllProviders() {
        try {
            const contractAddress = contractAddresses[this.networkType].providerRegistry;
            const contractAbi = ProviderRegistryAbi;
            const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
            const providersData = await contract.getAllProviders();
            const providers = providersData.map((provider) => {
                let name, region;
                try {
                    const { Name, Region } = JSON.parse(provider.spec);
                    name = Name;
                    region = Region;
                }
                catch {
                    try {
                        const { Name, Region } = decompressProviderSpec(provider.spec);
                        name = Name;
                        region = Region;
                    }
                    catch {
                        name = '';
                        region = '';
                    }
                }
                return {
                    providerId: provider.providerId.toString(),
                    name,
                    region,
                    walletAddress: provider.walletAddress,
                    paymentsAccepted: provider.paymentsAccepted,
                    spec: provider.spec,
                    hostUri: provider.hostUri,
                    certificate: provider.certificate,
                    status: FizzProviderStatus[provider.status],
                    // tier: FizzProviderTrustTier[provider.tier],
                    tier: Number(provider.tier.toString()),
                    joinTimestamp: Number(provider.joinTimestamp.toString()),
                    rewardWallet: provider.rewardWallet,
                };
            });
            return providers;
        }
        catch (error) {
            console.error('Failed to retrieve all providers: ', error);
            throw error;
        }
    }
    async getFizzLeases(fizzId, providerId, state) {
        try {
            const providerData = await this.getProvider(providerId);
            const walletAddress = providerData.walletAddress;
            const leaseContractAddress = contractAddresses[this.networkType].computeLease;
            const leaseContractAbi = ComputeLeaseAbi;
            const leaseContract = new ethers.Contract(leaseContractAddress, leaseContractAbi, this.provider);
            const [activeLeases, allLeases] = await leaseContract.getProviderLeases(walletAddress);
            const selectedLeases = state === 'ACTIVE' ? activeLeases : allLeases;
            const leases = [];
            for (const leaseId of selectedLeases) {
                const leaseData = await leaseContract.leases(leaseId);
                // Filter by fizzId
                if (leaseData.fizzId === fizzId) {
                    const lease = {
                        leaseId: leaseData.leaseId,
                        fizzId: leaseData.fizzId,
                        requestId: leaseData.requestId,
                        resourceAttribute: leaseData.resourceAttributes,
                        acceptedPrice: leaseData.acceptedPrice,
                        providerAddress: leaseData.providerAddress,
                        tenantAddress: leaseData.tenantAddress,
                        startBlock: leaseData.startBlock,
                        startTime: leaseData.startTime,
                        endTime: leaseData.endTime,
                        state: leaseData.state,
                    };
                    leases.push(lease);
                }
            }
            return leases;
        }
        catch (error) {
            console.error('Failed to retrieve fizz leases: ', error);
            throw error;
        }
    }
    async listenToFizzCreated(onSuccessCallback, onFailureCallback, timeoutTime = 60000) {
        const contractAddress = contractAddresses[this.networkType].fizzRegistry;
        const contractAbi = FizzRegistryAbi;
        try {
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            const webSocketProvider = new ethers.WebSocketProvider(this.rpcProvider.WSS_URL);
            const contract = new ethers.Contract(contractAddress, contractAbi, webSocketProvider);
            return new Promise((resolve, reject) => {
                this.timeoutId = setTimeout(() => {
                    contract.off('FizzNodeAdded');
                    webSocketProvider?.destroy();
                    onFailureCallback();
                    reject({ error: true, msg: 'Fizz creation failed' });
                }, timeoutTime);
                contract.on('FizzNodeAdded', (fizzId, walletAddress) => {
                    if (walletAddress.toString().toLowerCase() === accounts[0].toString().toLowerCase()) {
                        onSuccessCallback(fizzId, walletAddress);
                        webSocketProvider?.destroy();
                        contract.off('FizzNodeAdded');
                        clearTimeout(this.timeoutId);
                        resolve({ fizzId, walletAddress });
                    }
                });
            });
        }
        catch (error) {
            console.log('Error in listenToFizzCreated -> ', error);
            throw error;
        }
    }
    async updateFizzSpecs(specs) {
        try {
            const provider = new ethers.BrowserProvider(window.ethereum);
            await provider.send('eth_requestAccounts', []);
            const signer = await provider.getSigner();
            const contractAddress = contractAddresses[this.networkType].fizzRegistry;
            const contractAbi = FizzRegistryAbi;
            const contract = new ethers.Contract(contractAddress, contractAbi, signer);
            const tx = await contract.updateFizzSpec(specs);
            const receipt = await tx.wait();
            return receipt;
        }
        catch (error) {
            console.log('Error in updateFizzSpecs -> ', error);
            throw error;
        }
    }
    async listenSpecUpdated(onSuccessCallback, onFailureCallback, timeoutTime = 60000) {
        const contractAddress = contractAddresses[this.networkType].fizzRegistry;
        const contractAbi = FizzRegistryAbi;
        try {
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            const webSocketProvider = new ethers.WebSocketProvider(this.rpcProvider.WSS_URL);
            const contract = new ethers.Contract(contractAddress, contractAbi, webSocketProvider);
            let timeoutId;
            return new Promise((resolve, reject) => {
                timeoutId = setTimeout(() => {
                    contract.off('FizzNodeSpecUpdated');
                    webSocketProvider?.destroy();
                    onFailureCallback();
                    reject({ error: true, msg: 'Fizz update failed' });
                }, timeoutTime);
                contract.on('FizzNodeSpecUpdated', (fizzId, specs) => {
                    const fizz = this.getFizzById(fizzId);
                    if (fizz.walletAddress.toString().toLowerCase() === accounts[0].toString().toLowerCase()) {
                        onSuccessCallback(fizzId, specs, fizz.walletAddress);
                        webSocketProvider?.destroy();
                        contract.off('FizzNodeSpecUpdated');
                        clearTimeout(timeoutId);
                        resolve({ fizzId, specs, walletAddress: fizz.walletAddress });
                    }
                });
            });
        }
        catch (error) {
            console.log('Error in listenToFizzNodeUpdated -> ', error);
            throw error;
        }
    }
    async updateFizzRegion(region) {
        try {
            const provider = new ethers.BrowserProvider(window.ethereum);
            await provider.send('eth_requestAccounts', []);
            const signer = await provider.getSigner();
            const contractAddress = contractAddresses[this.networkType].fizzRegistry;
            const contractAbi = FizzRegistryAbi;
            const contract = new ethers.Contract(contractAddress, contractAbi, signer);
            const tx = await contract.updateFizzRegion(region);
            const receipt = await tx.wait();
            return receipt;
        }
        catch (error) {
            console.log('Error in updateFizzRegion -> ', error);
            throw error;
        }
    }
    async listenRegionUpdated(onSuccessCallback, onFailureCallback, timeoutTime = 60000) {
        const contractAddress = contractAddresses[this.networkType].fizzRegistry;
        const contractAbi = FizzRegistryAbi;
        try {
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            const webSocketProvider = new ethers.WebSocketProvider(this.rpcProvider.WSS_URL);
            const contract = new ethers.Contract(contractAddress, contractAbi, webSocketProvider);
            let timeoutId;
            return new Promise((resolve, reject) => {
                timeoutId = setTimeout(() => {
                    contract.off('FizzNodeRegionUpdated');
                    webSocketProvider?.destroy();
                    onFailureCallback();
                    reject({ error: true, msg: 'Fizz update failed' });
                }, timeoutTime);
                contract.on('FizzNodeRegionUpdated', (fizzId, region) => {
                    const fizz = this.getFizzById(fizzId);
                    if (fizz.walletAddress.toString().toLowerCase() === accounts[0].toString().toLowerCase()) {
                        onSuccessCallback(fizzId, region, fizz.walletAddress);
                        webSocketProvider?.destroy();
                        contract.off('FizzNodeRegionUpdated');
                        clearTimeout(timeoutId);
                        resolve({ fizzId, region, walletAddress: fizz.walletAddress });
                    }
                });
            });
        }
        catch (error) {
            console.log('Error in listenToFizzNodeUpdated -> ', error);
            throw error;
        }
    }
    async updateFizzProvider(providerId) {
        try {
            const provider = new ethers.BrowserProvider(window.ethereum);
            await provider.send('eth_requestAccounts', []);
            const signer = await provider.getSigner();
            const contractAddress = contractAddresses[this.networkType].fizzRegistry;
            const contractAbi = FizzRegistryAbi;
            const contract = new ethers.Contract(contractAddress, contractAbi, signer);
            const tx = await contract.updateFizzProviderId(providerId);
            const receipt = await tx.wait();
            return receipt;
        }
        catch (error) {
            console.log('Error in updateFizzProvider -> ', error);
            throw error;
        }
    }
    async listenProviderUpdated(onSuccessCallback, onFailureCallback, timeoutTime = 60000) {
        const contractAddress = contractAddresses[this.networkType].fizzRegistry;
        const contractAbi = FizzRegistryAbi;
        try {
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            const webSocketProvider = new ethers.WebSocketProvider(this.rpcProvider.WSS_URL);
            const contract = new ethers.Contract(contractAddress, contractAbi, webSocketProvider);
            let timeoutId;
            return new Promise((resolve, reject) => {
                timeoutId = setTimeout(() => {
                    contract.off('FizzNodeProviderIdUpdated');
                    webSocketProvider?.destroy();
                    onFailureCallback();
                    reject({ error: true, msg: 'Fizz update failed' });
                }, timeoutTime);
                contract.on('FizzNodeProviderIdUpdated', (fizzId, providerId) => {
                    const fizz = this.getFizzById(fizzId);
                    if (fizz.walletAddress.toString().toLowerCase() === accounts[0].toString().toLowerCase()) {
                        onSuccessCallback(fizzId, providerId, fizz.walletAddress);
                        webSocketProvider?.destroy();
                        contract.off('FizzNodeProviderIdUpdated');
                        clearTimeout(timeoutId);
                        resolve({ fizzId, providerId, walletAddress: fizz.walletAddress });
                    }
                });
            });
        }
        catch (error) {
            console.log('Error in listenToFizzNodeUpdated -> ', error);
            throw error;
        }
    }
    async addAcceptedPayment(tokenAddress) {
        try {
            const provider = new ethers.BrowserProvider(window.ethereum);
            await provider.send('eth_requestAccounts', []);
            const signer = await provider.getSigner();
            const contractAddress = contractAddresses[this.networkType].fizzRegistry;
            const contractAbi = FizzRegistryAbi;
            const contract = new ethers.Contract(contractAddress, contractAbi, signer);
            const tx = await contract.addAcceptedPayment(tokenAddress);
            const receipt = await tx.wait();
            return receipt;
        }
        catch (error) {
            console.log('Error in addAcceptedPayment -> ', error);
            throw error;
        }
    }
    async listenToAddAcceptedPayment(onSuccessCallback, onFailureCallback, timeoutTime = 60000) {
        const contractAddress = contractAddresses[this.networkType].fizzRegistry;
        const contractAbi = FizzRegistryAbi;
        try {
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            const webSocketProvider = new ethers.WebSocketProvider(this.rpcProvider.WSS_URL);
            const contract = new ethers.Contract(contractAddress, contractAbi, webSocketProvider);
            let timeoutId;
            return new Promise((resolve, reject) => {
                timeoutId = setTimeout(() => {
                    contract.off('PaymentAdded');
                    webSocketProvider?.destroy();
                    onFailureCallback();
                    reject({ error: true, msg: 'Fizz update failed' });
                }, timeoutTime);
                contract.on('PaymentAdded', (fizzId, tokenAddress) => {
                    const fizz = this.getFizzById(fizzId);
                    if (fizz.walletAddress.toString().toLowerCase() === accounts[0].toString().toLowerCase()) {
                        onSuccessCallback(fizzId, tokenAddress, fizz.walletAddress);
                        webSocketProvider?.destroy();
                        contract.off('PaymentAdded');
                        clearTimeout(timeoutId);
                        resolve({ fizzId, tokenAddress, walletAddress: fizz.walletAddress });
                    }
                });
            });
        }
        catch (error) {
            console.log('Error in listenToAddAcceptedPayment -> ', error);
            throw error;
        }
    }
    async removeAcceptedPayment(tokenAddress) {
        try {
            const provider = new ethers.BrowserProvider(window.ethereum);
            await provider.send('eth_requestAccounts', []);
            const signer = await provider.getSigner();
            const contractAddress = contractAddresses[this.networkType].fizzRegistry;
            const contractAbi = FizzRegistryAbi;
            const contract = new ethers.Contract(contractAddress, contractAbi, signer);
            const tx = await contract.removeAcceptedPayment(tokenAddress);
            const receipt = await tx.wait();
            return receipt;
        }
        catch (error) {
            console.log('Error in removeAcceptedPayment -> ', error);
            throw error;
        }
    }
    async listenToRemoveAcceptedPayment(onSuccessCallback, onFailureCallback, timeoutTime = 60000) {
        const contractAddress = contractAddresses[this.networkType].fizzRegistry;
        const contractAbi = FizzRegistryAbi;
        try {
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            const webSocketProvider = new ethers.WebSocketProvider(this.rpcProvider.WSS_URL);
            const contract = new ethers.Contract(contractAddress, contractAbi, webSocketProvider);
            let timeoutId;
            return new Promise((resolve, reject) => {
                timeoutId = setTimeout(() => {
                    contract.off('PaymentRemoved');
                    webSocketProvider?.destroy();
                    onFailureCallback();
                    reject({ error: true, msg: 'Fizz update failed' });
                }, timeoutTime);
                contract.on('PaymentRemoved', (fizzId, tokenAddress) => {
                    const fizz = this.getFizzById(fizzId);
                    if (fizz.walletAddress.toString().toLowerCase() === accounts[0].toString().toLowerCase()) {
                        onSuccessCallback(fizzId, tokenAddress, fizz.walletAddress);
                        webSocketProvider?.destroy();
                        contract.off('PaymentRemoved');
                        clearTimeout(timeoutId);
                        resolve({ fizzId, tokenAddress, walletAddress: fizz.walletAddress });
                    }
                });
            });
        }
        catch (error) {
            console.log('Error in listenToRemoveAcceptedPayment -> ', error);
            throw error;
        }
    }
    async removeFizzAttribute(category) {
        try {
            const provider = new ethers.BrowserProvider(window.ethereum);
            await provider.send('eth_requestAccounts', []);
            const signer = await provider.getSigner();
            const contractAddress = contractAddresses[this.networkType].fizzAttributeRegistry;
            const contractAbi = FizzAttributeRegistryAbi;
            const contract = new ethers.Contract(contractAddress, contractAbi, signer);
            const tx = await contract.removeAttributes(category);
            const receipt = await tx.wait();
            return receipt;
        }
        catch (error) {
            console.log('Error in removeFizzAttribute -> ', error);
            throw error;
        }
    }
}

class LeaseModule {
    constructor(provider, networkType = 'mainnet', rpcProvider) {
        this.networkType = networkType;
        this.provider = provider;
        this.rpcProvider = rpcProvider;
        this.getLeaseDetails = this.getLeaseDetails.bind(this);
        this.orderModule = new OrderModule(provider, networkType, rpcProvider);
        this.fizzModule = new FizzModule(provider, networkType, rpcProvider);
        this.leaseCloseTimeoutId = null;
    }
    async getLeaseDetails(leaseId) {
        const contractAbi = ComputeLeaseAbi;
        const contractAddress = contractAddresses[this.networkType].computeLease;
        const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
        const response = await contract.leases(leaseId);
        // const resourceAttribute = {
        //   cpuUnits: Number(response.resourceAttribute[0]),
        //   cpuAttributes: response.resourceAttribute[1],
        //   ramUnits: Number(response.resourceAttribute[2]),
        //   ramAttributes: response.resourceAttribute[3],
        //   gpuUnits: Number(response.resourceAttribute[4]),
        //   gpuAttributes: response.resourceAttribute[5],
        //   endpointsKind: Number(response.resourceAttribute[6]),
        //   endpointsSequenceNumber: Number(response.resourceAttribute[7]),
        // };
        const lease = {
            leaseId: response.leaseId.toString(),
            fizzId: response.fizzId.toString(),
            requestId: response.requestId.toString(),
            // resourceAttribute,
            acceptedPrice: Number(response.acceptedPrice),
            providerAddress: response.providerAddress.toString(),
            tenantAddress: response.tenantAddress.toString(),
            startBlock: response.startBlock.toString(),
            startTime: Number(response.startTime),
            endTime: Number(response.endTime),
            state: getLeaseStateAsString(response.state.toString()),
        };
        return lease;
    }
    async getLeaseIds(address) {
        const contractAbi = ComputeLeaseAbi;
        const contractAddress = contractAddresses[this.networkType].computeLease;
        const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
        const response = await contract.getTenantLeases(address);
        const activeLeaseIds = response[0].map((id) => id.toString());
        const allLeaseIds = response[1].map((id) => id.toString());
        const terminatedLeaseIds = allLeaseIds.filter((lId) => {
            return !activeLeaseIds.includes(lId);
        });
        return {
            activeLeaseIds,
            allLeaseIds,
            terminatedLeaseIds,
        };
    }
    async getLeasesByState(address, options) {
        const { activeLeaseIds, terminatedLeaseIds, allLeaseIds } = await this.getLeaseIds(address);
        let leaseIds = allLeaseIds;
        const totalCount = allLeaseIds.length;
        const terminatedCount = terminatedLeaseIds.length;
        const activeCount = activeLeaseIds.length;
        if (options?.state) {
            switch (options.state) {
                case LeaseState.ACTIVE:
                    leaseIds = activeLeaseIds;
                    break;
                case LeaseState.TERMINATED:
                    leaseIds = terminatedLeaseIds;
                    break;
            }
        }
        leaseIds.sort((a, b) => Number(b) - Number(a));
        if (options?.page) {
            const pageSize = options.pageSize || DEFAULT_PAGE_SIZE;
            leaseIds = leaseIds.slice((options.page - 1) * pageSize, options.page * pageSize);
        }
        const filteredLeases = await Promise.all(leaseIds.map((lId) => this.getLeaseDetails(lId)));
        const orderDetails = await Promise.all(leaseIds.map((lId) => this.orderModule.getOrderDetails(lId)));
        const leaseWithToken = await Promise.all(filteredLeases.map(async (lease, index) => {
            const order = orderDetails[index];
            let tokenDetails;
            if (order.token?.address)
                tokenDetails = getTokenDetails(order.token.address, this.networkType);
            let region;
            if (lease.fizzId.toString() !== '0') {
                const fizz = await this.fizzModule.getFizzById(BigInt(lease.fizzId));
                region = fizz?.region;
            }
            else {
                const provider = await this.fizzModule.getProviderByAddress(lease.providerAddress);
                region = provider?.region;
            }
            return {
                ...lease,
                name: order.name,
                tier: order.specs.tier,
                region: region,
                token: {
                    symbol: tokenDetails?.symbol,
                    decimal: tokenDetails?.decimal,
                },
                specs: decompressOrderSpec(order.specs.specs),
                numOfBlocks: order.numOfBlocks,
            };
        }));
        console.log('leases -> ', leaseWithToken);
        return {
            leases: leaseWithToken,
            activeCount,
            terminatedCount,
            totalCount,
        };
    }
    async closeLease(leaseId) {
        const contractAbi = ComputeLeaseAbi;
        const contractAddress = contractAddresses[this.networkType].computeLease;
        try {
            const provider = new ethers.BrowserProvider(window.ethereum);
            const signer = await provider.getSigner();
            const contract = new ethers.Contract(contractAddress, contractAbi, signer);
            const tx = await contract.closeLease(leaseId);
            const receipt = await tx.wait();
            return receipt;
        }
        catch (error) {
            console.log('Error in close lease ->', error);
            throw error;
        }
    }
    async listenToLeaseClosedEvent(onSuccessCallback, onFailureCallback, timeout = 60000) {
        const webSocketProvider = new ethers.WebSocketProvider(this.rpcProvider.WSS_URL);
        if (!webSocketProvider) {
            console.log('Please pass websocket provider in constructor');
            return;
        }
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        const contractAbi = ComputeLeaseAbi;
        const contractAddress = contractAddresses[this.networkType].computeLease;
        const contract = new ethers.Contract(contractAddress, contractAbi, webSocketProvider);
        return new Promise((resolve, reject) => {
            this.leaseCloseTimeoutId = setTimeout(() => {
                contract.off('LeaseClosed');
                webSocketProvider?.destroy();
                onFailureCallback();
                reject({ error: true, msg: 'Order Updation Failed' });
            }, timeout);
            contract.on('LeaseClosed', (orderId, providerAddress, tenantAddress) => {
                if (providerAddress.toString().toLowerCase() === accounts[0].toString().toLowerCase() ||
                    tenantAddress.toString().toLowerCase() === accounts[0].toString().toLowerCase()) {
                    onSuccessCallback({ orderId, providerAddress, tenantAddress });
                    webSocketProvider?.destroy();
                    contract.off('LeaseClosed');
                    clearTimeout(this.leaseCloseTimeoutId);
                    resolve({ orderId, providerAddress, tenantAddress });
                }
            });
        });
    }
}

var EscrowAbi = [
	{
		inputs: [
			{
				internalType: "address",
				name: "_tokenRegistryAddress",
				type: "address"
			},
			{
				internalType: "address",
				name: "_whitelistRegistry",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
		],
		name: "AccessControlBadConfirmation",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "bytes32",
				name: "neededRole",
				type: "bytes32"
			}
		],
		name: "AccessControlUnauthorizedAccount",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "target",
				type: "address"
			}
		],
		name: "AddressEmptyCode",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "AddressInsufficientBalance",
		type: "error"
	},
	{
		inputs: [
		],
		name: "DifferentOwnerExists",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ECDSAInvalidSignature",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "length",
				type: "uint256"
			}
		],
		name: "ECDSAInvalidSignatureLength",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "ECDSAInvalidSignatureS",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyOperatorArray",
		type: "error"
	},
	{
		inputs: [
		],
		name: "FailedInnerCall",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "available",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "required",
				type: "uint256"
			}
		],
		name: "InsufficientBalance",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidAmount",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidNonce",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidOperator",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidSignature",
		type: "error"
	},
	{
		inputs: [
		],
		name: "MinimumDepositNotMet",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ReentrancyGuardReentrantCall",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			}
		],
		name: "SafeERC20FailedOperation",
		type: "error"
	},
	{
		inputs: [
		],
		name: "SignatureExpired",
		type: "error"
	},
	{
		inputs: [
		],
		name: "TokenNotAccepted",
		type: "error"
	},
	{
		inputs: [
		],
		name: "TransferFailed",
		type: "error"
	},
	{
		inputs: [
		],
		name: "UnauthorizedAccess",
		type: "error"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "previousAdminRole",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "newAdminRole",
				type: "bytes32"
			}
		],
		name: "RoleAdminChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleGranted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleRevoked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint8",
				name: "movementType",
				type: "uint8"
			}
		],
		name: "TokenMovement",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "user",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "deposit",
				type: "uint256"
			}
		],
		name: "UserTokenLocked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "user",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "deposit",
				type: "uint256"
			}
		],
		name: "UserTokenUnlocked",
		type: "event"
	},
	{
		inputs: [
		],
		name: "DEFAULT_ADMIN_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "DEPOSIT_TYPEHASH",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "DOMAIN_SEPARATOR",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "WITHDRAW_TYPEHASH",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "deposit",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "_operators",
				type: "address[]"
			}
		],
		name: "depositForOperators",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "_operators",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "claimedSigner",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "signature",
				type: "bytes"
			},
			{
				internalType: "uint256",
				name: "nonce",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "depositForOperatorsWithSignature",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "claimedSigner",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "signature",
				type: "bytes"
			},
			{
				internalType: "uint256",
				name: "nonce",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "depositWithSignature",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			}
		],
		name: "getRoleAdmin",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_user",
				type: "address"
			},
			{
				internalType: "address",
				name: "_token",
				type: "address"
			},
			{
				internalType: "bool",
				name: "_isOperator",
				type: "bool"
			}
		],
		name: "getUserData",
		outputs: [
			{
				components: [
					{
						internalType: "uint128",
						name: "lockedBalance",
						type: "uint128"
					},
					{
						internalType: "uint128",
						name: "unlockedBalance",
						type: "uint128"
					}
				],
				internalType: "struct EscrowUser.UserTokenData",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "grantRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "hasRole",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_operator",
				type: "address"
			},
			{
				internalType: "address",
				name: "_token",
				type: "address"
			}
		],
		name: "isOperatorAddress",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_user",
				type: "address"
			},
			{
				internalType: "address",
				name: "_token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "_isOperator",
				type: "bool"
			}
		],
		name: "lockTokens",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "nonces",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "operatorBalance",
		outputs: [
			{
				internalType: "uint128",
				name: "lockedBalance",
				type: "uint128"
			},
			{
				internalType: "uint128",
				name: "unlockedBalance",
				type: "uint128"
			},
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_user",
				type: "address"
			},
			{
				internalType: "address",
				name: "_token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "_isOperator",
				type: "bool"
			}
		],
		name: "reduceLockedTokens",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "callerConfirmation",
				type: "address"
			}
		],
		name: "renounceRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "revokeRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes4",
				name: "interfaceId",
				type: "bytes4"
			}
		],
		name: "supportsInterface",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "tokenRegistry",
		outputs: [
			{
				internalType: "contract ITokenRegistry",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_token",
				type: "address"
			},
			{
				internalType: "address",
				name: "_rewardWallet",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "transferEarnedTokens",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_user",
				type: "address"
			},
			{
				internalType: "address",
				name: "_token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "_isOperator",
				type: "bool"
			}
		],
		name: "unlockTokens",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "userBalance",
		outputs: [
			{
				internalType: "uint128",
				name: "lockedBalance",
				type: "uint128"
			},
			{
				internalType: "uint128",
				name: "unlockedBalance",
				type: "uint128"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "whitelistRegistry",
		outputs: [
			{
				internalType: "contract IWhitelistRegistry",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "_operator",
				type: "address"
			}
		],
		name: "withdraw",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "_operator",
				type: "address"
			},
			{
				internalType: "address",
				name: "claimedSigner",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "signature",
				type: "bytes"
			},
			{
				internalType: "uint256",
				name: "nonce",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "withdrawWithSignature",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var TokenAbi = [
	{
		inputs: [
			{
				internalType: "uint256",
				name: "initialSupply",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "allowance",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "needed",
				type: "uint256"
			}
		],
		name: "ERC20InsufficientAllowance",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "balance",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "needed",
				type: "uint256"
			}
		],
		name: "ERC20InsufficientBalance",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "approver",
				type: "address"
			}
		],
		name: "ERC20InvalidApprover",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			}
		],
		name: "ERC20InvalidReceiver",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "ERC20InvalidSender",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			}
		],
		name: "ERC20InvalidSpender",
		type: "error"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "previousOwner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "newOwner",
				type: "address"
			}
		],
		name: "OwnershipTransferred",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				internalType: "uint8",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "mint",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "name",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "owner",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_newOwner",
				type: "address"
			}
		],
		name: "transferOwnership",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

class EscrowModule {
    constructor(provider, networkType = 'mainnet') {
        this.provider = provider;
        this.networkType = networkType;
    }
    // read operations
    async getProviderEarnings(providerAddress, tokenAddress) {
        try {
            const contractAbi = EscrowAbi;
            const contractAddress = contractAddresses[this.networkType].escrow;
            const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
            const response = await contract.getProviderEarnings(providerAddress, tokenAddress);
            const providerEarnings = {
                earned: response[0].toString(),
                withdrawn: response[1].toString(),
                balance: response[2].toString(),
            };
            return providerEarnings;
        }
        catch (error) {
            console.error('Error in getProviderEarnings:', error);
            throw error;
        }
    }
    async getUserBalance(providerAddress, tokenAddress) {
        try {
            const contractAbi = EscrowAbi;
            const contractAddress = contractAddresses[this.networkType].escrow;
            const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
            const response = await contract.getUserData(providerAddress, tokenAddress, false);
            const userData = {
                lockedBalance: response[0].toString(),
                unlockedBalance: response[1].toString(),
            };
            return userData;
        }
        catch (error) {
            console.error('Error in getUserData:', error);
            throw error;
        }
    }
    // write operations
    async withdrawProviderEarnings({ rewardWallet, tokenAddress, amount, decimals, onSuccessCallback, onFailureCallback, }) {
        if (typeof window?.ethereum === 'undefined') {
            console.log('Please install MetaMask');
            return;
        }
        try {
            await window.ethereum.request({ method: 'eth_requestAccounts' });
            const provider = new ethers.BrowserProvider(window.ethereum);
            const signer = await provider.getSigner();
            const contractABI = EscrowAbi;
            const contractAddress = contractAddresses[this.networkType].escrow;
            const contract = new ethers.Contract(contractAddress, contractABI, signer);
            const finalAmount = (Number(amount.toString()) - 1) / 10 ** decimals;
            const withdrawAmount = ethers.parseUnits(finalAmount.toFixed(decimals), decimals);
            const result = await contract.withdrawProviderEarnings(rewardWallet, tokenAddress, withdrawAmount);
            const receipt = await result.wait();
            console.log('Withdraw earnings successfull -> ', receipt);
            if (onSuccessCallback)
                onSuccessCallback(receipt);
            return receipt;
        }
        catch (error) {
            console.error('Error withdrawing provider earnings-> ', error);
            if (onFailureCallback)
                onFailureCallback(error);
            return error;
        }
    }
    async depositBalance({ tokenAddress, amount, decimals, onSuccessCallback, onFailureCallback, }) {
        if (typeof window?.ethereum === 'undefined') {
            console.log('Please install MetaMask');
            return;
        }
        try {
            await window.ethereum.request({ method: 'eth_requestAccounts' });
            const provider = new ethers.BrowserProvider(window.ethereum);
            const signer = await provider.getSigner();
            const contractABI = EscrowAbi;
            const contractAddress = contractAddresses[this.networkType].escrow;
            const tokenABI = TokenAbi;
            const contract = new ethers.Contract(contractAddress, contractABI, signer);
            const tokenContract = new ethers.Contract(tokenAddress, tokenABI, signer);
            const finalAmount = Number(amount.toString()) / 10 ** decimals;
            const depositAmount = ethers.parseUnits(finalAmount.toFixed(decimals), decimals);
            const approvalTxn = await tokenContract.approve(contractAddress, depositAmount);
            await approvalTxn.wait();
            const result = await contract.deposit(tokenAddress, depositAmount);
            const receipt = await result.wait();
            console.log('Deposit balance successfull -> ', receipt);
            if (onSuccessCallback)
                onSuccessCallback(receipt);
            return receipt;
        }
        catch (error) {
            console.error('Error balance deposit-> ', error);
            if (onFailureCallback)
                onFailureCallback(error);
            return error;
        }
    }
    async withdrawBalance({ tokenAddress, amount, decimals, onSuccessCallback, onFailureCallback, }) {
        if (typeof window?.ethereum === 'undefined') {
            console.log('Please install MetaMask');
            return;
        }
        try {
            await window.ethereum.request({ method: 'eth_requestAccounts' });
            const provider = new ethers.BrowserProvider(window.ethereum);
            const signer = await provider.getSigner();
            const contractABI = EscrowAbi;
            const contractAddress = contractAddresses[this.networkType].escrow;
            const contract = new ethers.Contract(contractAddress, contractABI, signer);
            const finalAmount = (Number(amount.toString()) - 1) / 10 ** decimals;
            const withdrawAmount = ethers.parseUnits(finalAmount.toFixed(decimals), decimals);
            const result = await contract.withdraw(tokenAddress, withdrawAmount);
            const receipt = await result.wait();
            console.log('Withdraw balance successfull -> ', receipt);
            if (onSuccessCallback)
                onSuccessCallback(receipt);
            return receipt;
        }
        catch (error) {
            console.error('Error in balance withdraw-> ', error);
            if (onFailureCallback)
                onFailureCallback(error);
            return error;
        }
    }
    async withdrawEarnings({ providerAddress, fizzId = '0', tokenAddress, amount, isFizz = false, onSuccessCallback, onFailureCallback, }) {
        if (typeof window?.ethereum === 'undefined') {
            console.log('Please install MetaMask');
            return;
        }
        try {
            await window.ethereum.request({ method: 'eth_requestAccounts' });
            const provider = new ethers.BrowserProvider(window.ethereum);
            const signer = await provider.getSigner();
            const contractABI = EscrowProtocolAbi;
            const contractAddress = contractAddresses[this.networkType].escrowProtocol;
            const contract = new ethers.Contract(contractAddress, contractABI, signer);
            const result = await contract.withdrawEarnings(providerAddress, fizzId, tokenAddress, amount, isFizz);
            const receipt = await result.wait();
            console.log('Withdraw earnings successfull -> ', receipt);
            if (onSuccessCallback)
                onSuccessCallback(receipt);
            return receipt;
        }
        catch (error) {
            console.error('Error withdrawing earnings-> ', error);
            if (onFailureCallback)
                onFailureCallback(error);
            return error;
        }
    }
}

class SpheronProviderModule {
    constructor(providerHostUrl, proxyUrl) {
        this.providerHostUrl = providerHostUrl;
        this.proxyUrl = proxyUrl;
    }
    async closeDeployment(certificate, authToken) {
        const url = `${this.proxyUrl}`;
        try {
            const response = await requestPipeline({
                url,
                method: 'POST',
                body: JSON.stringify({
                    certificate,
                    authToken,
                    url: `${this.providerHostUrl}/spheron/deployment/close`,
                    method: 'PUT',
                }),
            });
            return response;
        }
        catch (error) {
            console.log('Error in close deployment ->', error);
            throw error;
        }
    }
    async version() {
        const url = `${this.proxyUrl}`;
        try {
            const response = await requestPipeline({
                url,
                method: 'POST',
                body: JSON.stringify({
                    url: `${this.providerHostUrl}/version`,
                }),
            });
            return response;
        }
        catch (error) {
            console.log('Error in getting deployment version ->', error);
            throw error;
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async submitManfiest(certificate, authToken, leaseId, sdlManifest) {
        // if (!certificate) {
        //   console.log('Certificate not found');
        //   return;
        // }
        const url = `${this.proxyUrl}`;
        try {
            const reqBody = {
                certificate,
                authToken,
                method: 'PUT',
                url: `${this.providerHostUrl}/deployment/${leaseId}/manifest`,
                body: JSON.stringify(sdlManifest),
            };
            const response = await requestPipeline({
                url,
                method: 'POST',
                body: JSON.stringify(reqBody),
            });
            return response;
        }
        catch (error) {
            console.log('Error in submit manifest  ->', error);
            throw error;
        }
    }
    async getLeaseStatus(certificate, authToken, leaseId) {
        if (!leaseId) {
            console.log('Lease ID not found');
            return;
        }
        const reqBody = {
            certificate,
            authToken,
            method: 'GET',
            url: `${this.providerHostUrl}/lease/${leaseId}/${GSEQ}/${OSEQ}/status`,
        };
        const url = `${this.proxyUrl}`;
        try {
            const response = await requestPipeline({
                url,
                method: 'POST',
                body: JSON.stringify(reqBody),
            });
            return response;
        }
        catch (error) {
            console.log('Error in get lease status ->', error);
            throw error;
        }
    }
    async getKubeEvents(certificate, authToken, leaseId, service = '', tail = 100000) {
        if (!leaseId) {
            console.log('Lease ID not found');
            return;
        }
        const reqBody = {
            // eslint-disable-next-line prettier/prettier
            url: `${this.providerHostUrl}/lease/${leaseId}/${GSEQ}/${OSEQ}/kubeevents?follow=false&tail=${tail}${service ? `&service=${service}` : ''}`,
            method: 'GET',
            authToken,
            certificate,
        };
        const url = `${this.proxyUrl}`;
        try {
            const response = await requestPipeline({
                method: 'POST',
                body: JSON.stringify(reqBody),
                url,
            });
            return response;
        }
        catch (error) {
            console.log('Error in get kube events ->', error);
            throw error;
        }
    }
    async getLeaseLogs(certificate, authToken, leaseId, service = '', tail = 100000, startup = false) {
        if (!leaseId) {
            console.log('Lease ID not found');
            return;
        }
        const reqBody = {
            // eslint-disable-next-line prettier/prettier
            url: `${this.providerHostUrl}/lease/${leaseId}/${GSEQ}/${OSEQ}/logs?follow=false&tail=${tail}&startup=${startup}${service ? `&service=${service}` : ''}`,
            method: 'GET',
            authToken,
            certificate,
        };
        const url = `${this.proxyUrl}`;
        try {
            const response = await requestPipeline({
                url,
                method: 'POST',
                body: JSON.stringify(reqBody),
            });
            return response;
        }
        catch (error) {
            console.log('Error in get lease logs ->', error);
            throw error;
        }
    }
    async getLeaseServiceStatus(certificate, authToken, leaseId, serviceName) {
        if (!leaseId) {
            console.log('Lease ID not found');
            return;
        }
        if (!serviceName) {
            console.log('Service name not found');
            return;
        }
        const reqBody = {
            url: `${this.providerHostUrl}/lease/${leaseId}/${GSEQ}/${OSEQ}/service/${serviceName}/status`,
            method: 'GET',
            authToken,
            certificate,
        };
        const url = `${this.proxyUrl}`;
        try {
            const response = await requestPipeline({
                url,
                method: 'POST',
                body: JSON.stringify(reqBody),
            });
            return response;
        }
        catch (error) {
            console.log('Error in get lease service status ->', error);
            throw error;
        }
    }
    async leaseShell(certificate, authToken, leaseId) {
        if (!leaseId) {
            console.log('Lease ID not found');
            return;
        }
        const reqBody = {
            url: `${this.providerHostUrl}/lease/${leaseId}/${GSEQ}/${OSEQ}/shell`,
            method: 'POST',
            certificate,
            authToken,
        };
        const url = `${this.proxyUrl}`;
        try {
            const response = await requestPipeline({
                url,
                method: 'POST',
                body: JSON.stringify(reqBody),
            });
            return response;
        }
        catch (error) {
            console.log('Error in leaseShell ->', error);
            throw error;
        }
    }
}

class ProviderModule {
    constructor(provider, networkType = 'mainnet') {
        this.provider = provider;
        this.networkType = networkType;
    }
    async getProviderDetails(providerAddress) {
        if (!providerAddress) {
            console.log('Pass Provider Address');
            return;
        }
        if (!isValidEthereumAddress(providerAddress)) {
            console.log('Pass Valid Address');
            return;
        }
        try {
            const contractAbi = ProviderRegistryAbi;
            const contractAddress = contractAddresses[this.networkType].providerRegistry;
            const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
            const response = await contract.getProviderByAddress(providerAddress);
            const providerDetailsData = {
                spec: response[0],
                hostUri: response[1],
                certificate: response[2],
                paymentsAccepted: response[3],
                status: response[4].toString(),
                trust: Number(response[5].toString()) + 1,
                timestamp: Number(response[6].toString()),
            };
            return providerDetailsData;
        }
        catch (error) {
            console.log('Error in get Provider Details ->', error);
            return error;
        }
    }
    async getProviderPendingAttributes(providerAddress, category) {
        if (!providerAddress) {
            console.log('Pass Provider Address');
            return;
        }
        if (!isValidEthereumAddress(providerAddress)) {
            console.log('Pass Valid Address');
            return;
        }
        if (!category) {
            console.log('Please pass a category');
            return;
        }
        try {
            const contractAbi = ProviderRegistryAbi;
            const contractAddress = contractAddresses[this.networkType].providerRegistry;
            const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
            const response = await contract.getProviderPendingAttributes(providerAddress, category);
            return response;
        }
        catch (error) {
            console.log('Error in get Provider Pending Attrs ->', error);
            return error;
        }
    }
    async getProviderAttributes(providerAddress, category) {
        if (!providerAddress) {
            console.log('Pass Provider Address');
            return;
        }
        if (!isValidEthereumAddress(providerAddress)) {
            console.log('Pass Valid Address');
            return;
        }
        if (!category) {
            console.log('Please pass a category');
            return;
        }
        try {
            const contractAbi = ProviderRegistryAbi;
            const contractAddress = contractAddresses[this.networkType].providerRegistry;
            const contract = new ethers.Contract(contractAddress, contractAbi, this.provider);
            const response = await contract.getProviderAttributes(providerAddress, category);
            return response;
        }
        catch (error) {
            console.log('Error in get Provider Attrs ->', error);
            return error;
        }
    }
}

var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["SUCCESS"] = "success";
    TransactionStatus["FAILURE"] = "failure";
})(TransactionStatus || (TransactionStatus = {}));

class SpheronSDK {
    constructor(providerUrl = '', proxyUrl = '', networkType = 'mainnet', rpcProvider = {
        HTTP_URL: SPHERON_RPC_MAP[networkType].http,
        WSS_URL: SPHERON_RPC_MAP[networkType].wss,
    }) {
        this.networkType = networkType;
        const provider = new ethers.JsonRpcProvider(rpcProvider.HTTP_URL);
        this.leases = new LeaseModule(provider, networkType, rpcProvider);
        this.orders = new OrderModule(provider, networkType, rpcProvider);
        this.escrow = new EscrowModule(provider, networkType);
        this.provider = new ProviderModule(provider, networkType);
        this.fizz = new FizzModule(provider, networkType, rpcProvider);
        this.spheronProvider = new SpheronProviderModule(providerUrl, proxyUrl);
    }
}

export { FizzProviderStatus, FizzProviderTrustTier, LeaseState, Mode, OrderState, SpheronSDK, Tier, TransactionStatus };
//# sourceMappingURL=index.js.map
